<template>
    <side-bar-page>
    <template slot="content">
        <div class="content content-m">
            <!-- <button @click="test">test</button> -->
            <div class="content-fluid">
                <div>

                    <b-modal v-model="showMessageModal"
                            :title="$t('pr_m_send_msg_header') + user.firstName + ' ' + user.lastName"
                            :body-text-variant="'dark'"
                            :footer-text-variant="'dark'"
                            :headerClass="'message-header'"
                            :modalClass="'message-modal'"
                            :footerClass="'message-footer'"
                            :hide-footer="true"
                            >
                        <div class="container-fluid">
                            <div class="row">
                                <div class="col-md-12 disable-col-padding">
                                   <div class="form-group">
                                        <textarea class="form-control text-message" placeholder="..." v-model="newMessage"></textarea>
                                    </div>
                                    <button class="btn btn-fill float-right btn-primary btn-rounded" @click="sendMessage(user.id)">
                                        {{$t('pr_m_send_msg_btn')}}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </b-modal>
                </div>

                <div>
                    <b-modal v-model="showUploadImageModal"
                            :title="$t('pr_m_add_images')"
                            :body-text-variant="'dark'"
                            :footer-text-variant="'dark'"
                            :headerClass="'message-header'"
                            :modalClass="'message-modal'"
                            :footerClass="'message-footer'"
                            :hide-footer="true"
                            >
                        <div class="container-fluid">
                            <div class="row">
                                <div class="col-md-12 disable-col-padding">

                                    <p>
                                        {{$t('pr_m_image_upload_txt1')}} {{getUserProfile.photoLimit}} {{$t('pr_m_image_upload_txt2')}}
                                    </p>

                                    <picture-input 
                                        ref="pictureInput" 
                                        width="230" 
                                        height="230"
                                        @change="onUploadImgChange"
                                        @error="onUploadImgError"
                                        :crop="false"
                                        :zIndex="99999999"
                                        margin="0" 
                                        accept="image/jpeg,image/png,image/gif,image/bmp" 
                                        size="55" 
                                        :removable="true"
                                        :toggleAspectRatio="false"
                                        buttonClass="btn btn-primary button btns-upload"
                                        removeButtonClass="btn btn-danger button btns-upload"
                                        :customStrings="stringsPictureInput"
                                        :alertOnError="false">
                                    </picture-input>

                                    <div class="col-md-12">
                                        <div class="row">
                                            <div class="col-md-12 disable-col-padding">
                                                <label class="sr-only" for="inlineFormInputGroup">Title</label>
                                                <div class="input-group mb-2 upload-img-title">
                                                    <div class="input-group-prepend">
                                                    <div class="input-group-text"><i class="fa fa-picture-o" aria-hidden="true"></i></div>
                                                    </div>
                                                    <input type="text" v-model="uploadedImgTitle" :placeholder="$t('pr_m_placeholder_title')" class="form-control valid" maxlength="50">
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <button v-if="!isUploadingImgGallery" class="btn btn-fill float-right btn-primary btn-rounded btn-upload-gallery" @click="postGalleryImage()">
                                        {{$t('pr_m_upload_img')}}
                                    </button>
                                    <sync-loader v-if="isUploadingImgGallery" class="text-center" color="#a82d38"></sync-loader>
                                </div>
                            </div>
                        </div>
                    </b-modal>
                </div>

                <div>
                    <b-modal v-model="showUploadVideoModal"
                            :title="$t('pr_m_add_videos')"
                            :body-text-variant="'dark'"
                            :footer-text-variant="'dark'"
                            :headerClass="'message-header'"
                            :modalClass="'message-modal'"
                            :footerClass="'message-footer'"
                            :hide-footer="true"
                            >
                        <div class="container-fluid">
                            <div class="row">
                                <div class="col-md-12 disable-col-padding">
                                    <form action="javascript:void(0);" v-on:submit="postGalleryVideo()">
                                    <p>{{$t('pr_m_video_upload_txt')}}</p>
                                    <div class="row">
                                        <div class="col-md-6">
                                            <div class="form-group has-label">
                                                <input type="radio" name="videoRadios" id="youtubeRadio" value="youtube" v-model="video.media"/>
                                                <label class="form-radio" for="youtubeRadio"><span>{{$t('pr_m_youtube')}}</span></label>
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <div class="form-group has-label">
                                                <input type="radio" name="videoRadios" id="vimeoRadio" value="vimeo" v-model="video.media"/>
                                                <label class="form-radio" for="vimeoRadio"><span>{{$t('pr_m_vimeo')}}</span></label>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-12 disable-col-padding">
                                        <label class="sr-only" for="inlineFormInputGroup">Title</label>
                                        <div class="input-group mb-2">
                                            <div class="input-group-prepend">
                                            <div class="input-group-text"><i class="fa fa-picture-o" aria-hidden="true"></i></div>
                                            </div>
                                            <input type="text" v-model="video.title" :placeholder="$t('pr_m_placeholder_title_video')" class="form-control valid" maxlength="50">
                                        </div>
                                    </div>
                                    <div class="col-md-12 disable-col-padding">
                                        <label class="sr-only" for="inlineFormInputGroup">Title</label>
                                        <div class="input-group mb-2">
                                            <div class="input-group-prepend">
                                            <div class="input-group-text"><i class="fa fa-link" aria-hidden="true"></i></div>
                                            </div>
                                            <input v-if="video.media === 'youtube'" type="text" v-model="video.href" :placeholder="$t('pr_m_placeholder_link_youtube')" class="form-control valid input-full" maxlength="100" required>
                                            <input v-if="video.media === 'vimeo'" type="text" v-model="video.href" :placeholder="$t('pr_m_placeholder_link_vimeo')" class="form-control valid input-full" maxlength="100" required>
                                        </div>
                                    </div>
                                    <button type="submit" v-if="!isUploadingVideoGallery" class="btn btn-fill float-right btn-primary btn-rounded btn-upload-gallery">
                                        {{$t('pr_m_upload_video')}}
                                    </button>
                                    <sync-loader v-if="isUploadingVideoGallery" class="text-center" color="#a82d38"></sync-loader>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </b-modal>
                </div>

                <div>
                    <b-modal v-model="showDeleteVideoModal"
                            :title="$t('pr_m_del_videos')"
                            :body-text-variant="'dark'"
                            :footer-text-variant="'dark'"
                            :headerClass="'message-header'"
                            :modalClass="'manage-gallery-modal'"
                            :footerClass="'message-footer'"
                            :hide-footer="true"
                            >
                        <div class="container-fluid">
                            <div class="row">
                                <div class="col-md-12 disable-col-padding">
                                    <form action="javascript:void(0);">
                                    <div class="row">
                                        <div class="col-md-4 manage-col" v-for="(video, index) in videos" :key="index">
                                            <div class="video-container">
                                                <div class="delete-file-btn" @click="deleteVideoGallery(index)"><i class="fa fa-times-circle"></i></div>
                                                <img class="manage-gallery-video" :src="video.poster">
                                                <div class="overlay-manage">
                                                    <div class="overlay-text-manage">{{ (video.title !== null) && (typeof video.title !== 'undefined') && (video.title !== ' ') && (video.title !== '') ? video.title : $t('pr_no_title')}}</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    </form>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-12">
                                    <sync-loader v-if="isDeletingVideoGallery" class="text-center" color="#a82d38"></sync-loader>
                                </div>
                            </div>
                        </div>
                    </b-modal>
                </div>

                <div>
                    <b-modal v-model="showDeleteImageModal"
                            :title="$t('pr_m_del_images')"
                            :body-text-variant="'dark'"
                            :footer-text-variant="'dark'"
                            :headerClass="'message-header'"
                            :modalClass="'manage-gallery-modal'"
                            :footerClass="'message-footer'"
                            :hide-footer="true"
                            >
                        <div class="container-fluid">
                            <div class="row">
                                <div class="col-md-12 disable-col-padding">
                                    <form action="javascript:void(0);">
                                    <div class="row">
                                        <div class="col-md-4 manage-col" v-for="(image, index) in images" :key="index">
                                            <div class="video-container">
                                                <div class="delete-file-btn" @click="deleteImageGallery(index)"><i class="fa fa-times-circle"></i></div>
                                                <div class="manage-gallery-image"
                                                    :style="{ backgroundImage: 'url(' + image.href + ')'}">
                                                </div>
                                                <div class="overlay-manage">
                                                    <div class="overlay-text-manage">{{ (image.title !== null) && (typeof image.title !== 'undefined') && (image.title !== ' ') && (image.title !== '') ? image.title : $t('pr_no_title')}}</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    </form>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-12">
                                    <sync-loader v-if="isDeletingImageGallery" class="text-center" color="#a82d38"></sync-loader>
                                </div>
                            </div>
                        </div>
                    </b-modal>
                </div>

                <b-modal v-model="showAgreementModal"
                    :title="$t('pr_finish_registration_header')"
                    :body-text-variant="'dark'"
                    :footer-text-variant="'dark'"
                    :headerClass="'message-header'"
                    :modalClass="'reg-modal'"
                    :footerClass="'message-footer'"
                    :hide-footer="true"
                    :no-close-on-esc="true"
                    :no-close-on-backdrop="true"
                    :hide-header-close="true"
                    >
                    <div class="container-fluid">
                        <div class="row">
                            <div class="col-md-12 disable-col-padding">
                                <form action="javascript:void(0);" @submit="submitAgreementModal()">
                                <p>{{$t('pr_finish_registration_text')}}</p>

                                <div class="row">
                                    <div class="col-md-5">
                                        <div class="form-group has-label">
                                            <input type="radio" name="typeRadiosModal" id="artistRadioModal" value="artist" v-model="userEdit.userType"/>
                                            <label class="form-radio" for="artistRadioModal"><span class="modal-radio nowrap">{{$t('pr_artist_modal')}}</span></label>
                                        </div>
                                    </div>
                                    <div class="col-md-5">
                                        <div class="form-group has-label">
                                            <input type="radio" name="typeRadiosModal" id="agentRadioModal" value="agent" v-model="userEdit.userType"/>
                                            <label class="form-radio" for="agentRadioModal"><span class="modal-radio nowrap">{{$t('pr_agent_modal')}}</span></label>
                                        </div>
                                    </div>
                                </div>

                                <div class="row row-agreement">
                                    <div class="col-md-12">
                                    <div class="form-group has-label">
                                        <input type="checkbox" name="agreementCheckbox" id="agreementRadio" v-model="userEdit.isAgreementAccepted" required/>
                                        <label class="form-checkbox form-checkbox-modal" for="agreementRadio">
                                            <span class="agreement-label">
                                                <!-- {{ $t('reg_agreement') }} <a href="/terms-and-condition" target="_blank">{{ $t('reg_agreement_part') }}</a> <span class="require-sign">*</span> -->
                                                {{ $t('reg_agreement') }} 
                                                <router-link :to="{name: 'termsAndCondition'}" target="_blank" class="link">{{ $t('reg_agreement_part') }}</router-link>
                                                {{ $t('and') }} 
                                                <router-link :to="{name: 'privacyPolicy'}" target="_blank" class="link">{{ $t('reg_privacy_policy') }}</router-link>
                                                universtage.com
                                            </span>
                                        </label>
                                    </div>
                                    </div>
                                </div>

                                <button type="submit" v-if="!isUserSending" class="btn btn-fill float-right btn-primary btn-rounded btn-upload-gallery btn-two">
                                    {{$t('pr_registration_next')}}
                                </button>
                                <sync-loader v-if="isUserSending" class="text-center" color="#a82d38"></sync-loader>
                                </form>
                            </div>
                        </div>
                    </div>
                </b-modal>

        <b-modal v-model="showPasswordModal"
              :title="$t('deleteAccountConfirm')"
              :body-text-variant="'dark'"
              :footer-text-variant="'dark'"
              :headerClass="'message-header'"
              :modalClass="'reg-modal password'"
              :footerClass="'message-footer'"
              :hide-footer="true"
              :no-close-on-esc="true"
              :no-close-on-backdrop="true"
              :hide-header-close="true"
              >
          <div class="container-fluid">
              <div class="row">
                  <div class="col-md-12 disable-col-padding">
                      <form action="javascript:void(0);" @submit="checkPassword()">
                      <p>{{$t('deleteAccountText')}}</p>
                      <div class="form-group">
                        <input type="password" class="form-control" v-model="checkPass.password" id="password" :placeholder="$t('passwordUpper')" autofocus>
                      </div>
                      <button v-if="!isUserSending" class="btn btn-outline-danger btn-filter btn-filter-i" type="submit">
                        {{$t('deleteAccountBtn')}}
                      </button>
                      <button class="btn btn-outline-danger btn-filter btn-filter-i btn-filter-alt btn-filter-alt-i" type="button" @click="cancelDeleteAccount()">
                        {{$t('deleteAccountBtnCancel')}}
                      </button>
                      <sync-loader v-if="isUserSending" class="text-center" color="#a82d38"></sync-loader>
                      </form>
                  </div>
              </div>
          </div>
        </b-modal>

        <!-- <button @click="test">test</button> -->
        <b-tabs content-class="mt-3 container-fluid" class="rating-tab">
            <!-- <b-tab @click="loadProfile()" :title="(isLogin && $route.params.id===getUserProfile.id) ? $t('pr_tab_1') : $t('pr_tab_1_1')" active> -->
            <b-tab :title="(isLogin && $route.params.id===getUserProfile.id) ? $t('pr_tab_1') : $t('pr_tab_1_1')" active>
                <div class="row">
                    <div class="col-md-12 mobile-container">
                        <div class="card">
                            <div class="card-cover">
                                <div class="cover-img cover-default"></div>
                            </div>
                            <div class="card-body">
                                <div class="row">
                                    <div class="col-md-3">
                                        <div class="user">
                                            <img :src="profilePhoto" class="avatar border-gray">
                                        </div>
                                    </div>
                                    <div class="col-md-9">
                                        <div class="user-title">
                                            <div class="title">
                                                <span v-if="user.userCategory !== 'team'">{{user.firstName}} {{user.lastName}}</span>
                                                <span v-if="user.userCategory === 'team'">{{user.teamName}}</span>
                                                <span class="hidden-xs social-buttons-block" v-if="isLogin && $route.params.id!=getUserProfile.id">
                                                    <button class="btn btn-info btn-fill btn-wd btn-icon" @click="writeMessage()">
                                                        <i class="fa fa-pencil-square-o"></i> <span class="btn-txt">{{$t('pr_m_msg_btn')}}</span>
                                                    </button>
                                                    <!-- <button class="btn btn-info btn-fill btn-wd btn-icon">
                                                        <i class="fa fa-plus"></i> <span class="btn-txt">{{$t('pr_m_follow_btn')}}</span>
                                                    </button> -->
                                                </span>
                                                <span class="hidden-xs social-buttons-block" v-if="user.userType !=='agent' && user.propsList && user.propsList.length">
                                                    <button class="btn btn-info btn-fill btn-wd btn-icon-full" @click="modalProps=true">
                                                        <i class="fa fa-folder-open-o"></i> <span class="btn-txt">{{$t('pr_show_props')}}</span>
                                                    </button>
                                                </span>
                                            </div>
                                            <props ref="modalProps" :propsList="user.propsList" :modalShow="modalProps" :showButtons="false" @props-close="modalProps=false"></props>
                                            <small v-if="user.userCategory === 'team'">{{$t('pr_m_circus_team')}}</small>
                                            <small v-if="user.userCategory === 'artist'">{{$t('pr_m_artist')}}</small>
                                            <small v-if="user.userCategory === 'agent'">{{$t('pr_m_agent')}}</small>
                                            <small v-if="user.userCategory === 'employer'">{{$t('pr_m_employer')}}</small>
                                            <div class="hidden-md visible-xs" v-if="isLogin && $route.params.id!=getUserProfile.id">
                                                <div class="btn-mobile-block">
                                                    <button class="btn btn-info btn-fill btn-wd btn-icon" @click="writeMessage()">
                                                        <i class="fa fa-pencil-square-o"></i> <span class="btn-txt">{{$t('pr_m_msg_btn')}}</span>
                                                    </button>
                                                    <!-- <button class="btn btn-info btn-fill btn-wd btn-icon">
                                                        <i class="fa fa-plus"></i> <span class="btn-txt">{{$t('pr_m_follow_btn')}}</span>
                                                    </button> -->
                                                </div>
                                            </div>
                                            <div class="hidden-md visible-xs" v-if="user.userType !=='agent' && user.propsList && user.propsList.length">
                                                <div class="btn-mobile-block">
                                                    <button class="btn btn-info btn-fill btn-wd btn-icon-full" @click="modalProps=true">
                                                        <i class="fa fa-folder-open-o"></i> <span class="btn-txt">{{$t('pr_show_props')}}</span>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-2"></div>
                                    <div class="col-md-8">
                                        <p class="description text-center">
                                            <!-- <span>{{user.aboutMe}}</span> -->
                                            <span v-html='aboutMeHtml'></span>
                                        </p>
                                    </div>
                                    <div class="col-md-2"></div>
                                </div>
                                <div class="row">
                                    <div class="col-md-5 offset-md-1 col-mobile-margin">
                                        <div class="base-info-txt">
                                            <p v-if="user.isPhoneAllowed && isLogin && user.phone1"><i class="fa fa-phone fa-info-block" aria-hidden="true"></i> <a class="data" :href="'tel:'+user.phone1">{{user.phone1}}</a></p>
                                            <p v-if="user.isEmailAllowed && isLogin && !user.isSocialRegister">
                                                <i class="fa fa-envelope fa-info-block" aria-hidden="true"></i> <a class="data" :href="'mailto:'+user.email">{{user.email}}</a>
                                            </p>
                                            <p v-if="user.isEmailAllowed && isLogin && user.isSocialRegister && (typeof user.email2 !== 'undefined') && (user.email2 !== null)">
                                                <i class="fa fa-envelope fa-info-block" aria-hidden="true"></i> <a class="data" :href="'mailto:'+user.email2">{{user.email2}}</a>
                                            </p>
                                            <p v-if="user.googlePlaceLocales && user.googlePlaceLocales[currentLng] && user.googlePlaceLocales[currentLng].country"><i class="fa fa-flag fa-info-block" aria-hidden="true"></i> <span class="data">{{(user.googlePlaceLocales && user.googlePlaceLocales[currentLng] && user.googlePlaceLocales[currentLng].country)}}</span></p>
                                            <p v-if="user.googlePlaceLocales && user.googlePlaceLocales[currentLng] && user.googlePlaceLocales[currentLng].city"><i class="fa fa-globe fa-info-block" aria-hidden="true"></i> <span class="data">{{(user.googlePlaceLocales && user.googlePlaceLocales[currentLng] && user.googlePlaceLocales[currentLng].city)}}</span></p>
                                        </div>
                                    </div>
                                    <div class="col-md-5 offset-md-1" v-for="(artist, index) in range(0, 1, user.artistTypesList)" :value="artist" :key="index" :hidden="user.userCategory == 'agent'">
                                        <div class="base-info-txt">
                                            <p><i class="fa fa-id-badge fa-info-block" aria-hidden="true"></i> <span class="data">{{getArtistType(artist.artistTypeId)['type_'+currentLng]}}</span></p>
                                            <p><i class="fa fa-key fa-info-block" aria-hidden="true"></i> <span class="data">{{getCategory(artist.artistTypeId, artist.categories)['name_'+currentLng]}}</span></p>
                                            <p><i class="fa fa-trophy fa-info-block" aria-hidden="true"></i> <span class="data">{{getSkill(artist.skill)['skill_'+currentLng]}}</span></p>
                                            <p><span v-if="user.artistTypesList.length > 1" class="data more-info-btn" v-b-toggle="'collapseSkills'" @click="collapseSkills()">
                                                    <span v-if="isCollapse" class="hidden-xs">{{$t('pr_m_less_info')}}</span> 
                                                    <span v-if="!isCollapse">{{$t('pr_m_more_info')}}</span>
                                               </span>
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <b-collapse id="collapseSkills">
                                    <div class="row">
                                        <div class="col-md-5 offset-md-1 artistSkills" v-for="(artist, index) in range(1, user.artistTypesList.length, user.artistTypesList)" :value="artist" :key="index">
                                            <div class="base-info-txt">
                                                <p><i class="fa fa-id-badge fa-info-block" aria-hidden="true"></i> <span class="data">{{getArtistType(artist.artistTypeId)['type_'+currentLng]}}</span></p>
                                                <p><i class="fa fa-key fa-info-block" aria-hidden="true"></i> <span class="data">{{getCategory(artist.artistTypeId, artist.categories)['name_'+currentLng]}}</span></p>
                                                <p><i class="fa fa-trophy fa-info-block" aria-hidden="true"></i> <span class="data">{{getSkill(artist.skill)['skill_'+currentLng]}}</span></p>
                                            </div>
                                        </div>
                                        <div class="col-md-12 visible-xs">
                                            <p>
                                                <span class="data more-info-btn" v-b-toggle="'collapseSkills'" @click="collapseSkills()">
                                                    <span v-if="isCollapse">{{$t('pr_m_less_info')}}</span> 
                                                </span>
                                            </p>
                                        </div>
                                    </div>
                                </b-collapse>
                                <div class="row">
                                    <div class="col-md-5 offset-md-1" v-for="(exp, index) in range(0, 1, user.experienceList)" :value="exp" :key="'exp'+index" :hidden="user.userCategory == 'agent'">
                                        <p><img style="padding-right: 15px; height: 30px; opacity: 0.5;" src="../assets/img/icons/circus.png"/>{{$t('experience')}}</p>
                                        <div class="base-info-txt">
                                            <p><i class="fa fa-id-badge fa-info-block" aria-hidden="true"></i> <span class="data">{{exp.name}}</span></p>
                                            <p v-if="exp.month_start" style="margin-left: 18px;"><span class="data">{{$i18n.messages[currentLng].months[exp.month_start-1]}} {{exp.year_start}}{{exp.month_end ? ` - ${$i18n.messages[currentLng].months[exp.month_end-1]} ${exp.year_end}`:''}}</span></p>
                                            <!-- <p v-if="exp.month_end"><span class="data">{{$i18n.messages[currentLng].months[exp.month_end-1]}} {{exp.year_end}}</span></p> -->
                                            <p><span v-if="user.experienceList.length > 1" class="data more-info-btn" v-b-toggle="'collapseExpirience'" @click="isCollapseExp=!isCollapseExp">
                                                    <span v-if="isCollapseExp" class="hidden-xs">{{$t('pr_m_less_info')}}</span> 
                                                    <span v-if="!isCollapseExp">{{$t('pr_m_more_info')}}</span>
                                               </span>
                                            </p>
                                        </div>
                                    </div>
                                    <div class="col-md-5 offset-md-1" v-for="(exp, index) in range(1, user.experienceList.length, user.experienceList)" :value="exp" :key="'exp'+index+1" :hidden="user.userCategory == 'agent' || !isCollapseExp">
                                        <div class="base-info-txt">
                                            <p><i class="fa fa-id-badge fa-info-block" aria-hidden="true"></i> <span class="data">{{exp.name}}</span></p>
                                            <p v-if="exp.month_start" style="margin-left: 18px;"><span class="data">{{$i18n.messages[currentLng].months[exp.month_start-1]}} {{exp.year_start}}{{exp.month_end ? ` - ${$i18n.messages[currentLng].months[exp.month_end-1]} ${exp.year_end}`:''}}</span></p>
                                            <!-- <p v-if="exp.month_end"><span class="data">{{$i18n.messages[currentLng].months[exp.month_end-1]}} {{exp.year_end}}</span></p> -->
                                        </div>
                                    </div>
                                    <div class="col-md-12 visible-xs" v-if="isCollapseExp">
                                        <p>
                                            <span class="data more-info-btn" v-b-toggle="'collapseEducation'" @click="isCollapseExp=!isCollapseExp">
                                                <span v-if="isCollapseExp">{{$t('pr_m_less_info')}}</span> 
                                            </span>
                                        </p>
                                    </div>
                                    <div class="col-md-5 offset-md-1" v-for="(edu, index) in range(0, 1, user.educationList)" :value="edu" :key="'edu'+index" :hidden="user.userCategory == 'agent'">
                                        <p style=""><i class="fa fa-info-block fa-graduation-cap fa-2x" style="padding-right: 15px;" aria-hidden="true"></i>{{$t('education')}}</p>
                                        <div class="base-info-txt">
                                            <p><i class="fa fa-id-badge fa-info-block" aria-hidden="true"></i> <span class="data">{{edu.name}}</span></p>
                                            <p v-if="edu.faculty && edu.faculty.length" style="margin-left: 18px;"><span class="data">{{edu.faculty}}</span></p>
                                            <p v-if="edu.specialization && edu.specialization.length" style="margin-left: 18px;"><span class="data">{{edu.specialization}}</span></p>
                                            <p v-if="edu.yearOfEnding" style="margin-left: 18px;"><span class="data">{{edu.yearOfEnding}}</span></p>
                                            <p><span v-if="user.educationList.length > 1" class="data more-info-btn" v-b-toggle="'collapseEducation'" @click="isCollapseEdu=!isCollapseEdu">
                                                    <span v-if="isCollapseEdu" class="hidden-xs">{{$t('pr_m_less_info')}}</span> 
                                                    <span v-if="!isCollapseEdu">{{$t('pr_m_more_info')}}</span>
                                               </span>
                                            </p>
                                        </div>
                                    </div>
                                    <div class="col-md-5 offset-md-1" v-for="(edu, index) in range(1, user.educationList.length, user.educationList)" :value="edu" :key="'edu'+index+1" :hidden="user.userCategory == 'agent' || !isCollapseEdu">
                                        <div class="base-info-txt">
                                            <p><i class="fa fa-id-badge fa-info-block" aria-hidden="true"></i> <span class="data">{{edu.name}}</span></p>
                                            <p v-if="edu.faculty && edu.faculty.length" style="margin-left: 18px;"><span class="data">{{edu.faculty}}</span></p>
                                            <p v-if="edu.specialization && edu.specialization.length" style="margin-left: 18px;"><span class="data">{{edu.specialization}}</span></p>
                                            <p v-if="edu.yearOfEnding" style="margin-left: 18px;"><span class="data">{{edu.yearOfEnding}}</span></p>
                                        </div>
                                    </div>
                                    <div class="col-md-12 visible-xs" v-if="isCollapseEdu">
                                        <p>
                                            <span class="data more-info-btn" v-b-toggle="'collapseEducation'" @click="isCollapseEdu=!isCollapseEdu">
                                                <span v-if="isCollapseEdu">{{$t('pr_m_less_info')}}</span> 
                                            </span>
                                        </p>
                                    </div>
                                </div>
                                <div class="row row-gallery-title">
                                    <div class="col-md-12 disable-col-padding">
                                        <span class="image-gallery-label">{{$t('pr_m_photo')}}</span>
                                        <span class="image-gallery-label" v-if="isLogin && $route.params.id===getUserProfile.id">
                                            <span class="add-image-btn" @click="uploadImages()">
                                                |<i class="fa fa-plus"></i>{{$t('pr_m_photo_add')}}
                                            </span>
                                        </span>
                                        <span class="image-gallery-label" v-if="isLogin && $route.params.id===getUserProfile.id">
                                            <span class="add-image-btn" @click="deleteImages()">
                                                |<i class="fa fa-sliders"></i>{{$t('pr_m_photo_manage')}}
                                            </span>
                                        </span>
                                    </div>
                                </div>
                                <div class="row row-gallery" :class="{ nomedia: !images || (images.length < 1)}">
                                    <div class="col-md-12 disable-col-padding">
                                        <gallery :input="images" :index="index" @close="index = null"></gallery>
                                        <div class="image gallery-image" v-for="(image, imageIndex) in images" :key="imageIndex"
                                            @click="index = imageIndex" 
                                            :style="{ backgroundImage: 'url(' + image.href + ')'}">
                                            <div class="overlay">
                                                <div class="overlay-text">{{image.title}}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-12 disable-col-padding">
                                        <span class="image-gallery-label">{{$t('pr_m_video')}}</span>
                                        <span class="image-gallery-label" v-if="isLogin && $route.params.id===getUserProfile.id">
                                            <span class="add-video-btn" @click="uploadVideos()">
                                                |<i class="fa fa-plus"></i>{{$t('pr_m_video_add')}}
                                            </span>
                                        </span>
                                        <span class="image-gallery-label" v-if="isLogin && $route.params.id===getUserProfile.id">
                                            <span class="add-video-btn" @click="deleteVideos()">
                                                |<i class="fa fa-sliders"></i>{{$t('pr_m_video_manage')}}
                                            </span>
                                        </span>
                                    </div>
                                </div>
                                <div class="row row-gallery-video" :class="{ nomedia: !videos || (videos.length < 1)}">
                                    <div class="col-md-12 disable-col-padding">
                                        <gallery 
                                            :input="videos" 
                                            :index="indexVideo"
                                            :clickToPlay="false"
                                            @close="indexVideo = null"
                                        ></gallery>
                                        <div class="video gallery-image"
                                            v-for="(video, videoIndex) in videos" :key="videoIndex"
                                            @click="indexVideo = inputOver ? null : videoIndex"
                                            :style="{ backgroundImage: 'url(' + video.poster + ')'}">
                                            <div v-if="isAdmin && isMobileResolution" @mouseover="inputOver = true" @mouseleave="inputOver = false">
                                                <input v-model="video.hashTag" @input="video.hashTagEdit = true" placeholder="Set hash tag"/>
                                                <button v-if="video.hashTagEdit" @click="saveHashTag(video)">save</button>
                                            </div>
                                            <div v-if="!isMobileResolution" class="overlay">
                                                <div v-if="isAdmin" @mouseover="inputOver = true" @mouseleave="inputOver = false">
                                                    <input v-model="video.hashTag" @input="video.hashTagEdit = true" placeholder="Set hash tag"/>
                                                    <button v-if="video.hashTagEdit" @click="saveHashTag(video)">save</button>
                                                </div>
                                                <div class="overlay-text">{{video.title}}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </b-tab>

            <b-tab :title="$t('pr_tab_2')" v-if="isLogin && $route.params.id===getUserProfile.id">
                <div class="row">
                    <div class="col-lg-8 col-md-7 mobile-container" id="second">
                        <div class="card">
                            <div class="card-header">
                                <h4 class="title title-header">{{$t('pr_header')}}</h4>
                            </div>
                            <div class="card-body">
                                    <form id="main-form" action="javascript:void(0);" @submit="updateUserProfile()">
                                    <div class="row">
                                        <div class="col-md-12">
                                        <p class="p-title"><i class="fa fa-flag-checkered fa-2x" style="padding-right: 15px;" aria-hidden="true"></i>{{$t('pr_intro')}}</p>
                                        </div>
                                    </div>
                                    <div class="row">
                                            <div class="col-md-6" v-if="userEdit.userType == 'artist'">
                                            <div class="form-group has-label">
                                                <input type="radio" name="categoryRadios" id="artistRadio" value="artist" v-model="userEdit.userCategory"/>
                                                <label class="form-radio" for="artistRadio"><span>{{$t('pr_artist')}}</span></label>
                                            </div>
                                            </div>
                                            <div class="col-md-6" v-if="userEdit.userType == 'artist'">
                                                <div class="form-group has-label">
                                                <input type="radio" name="categoryRadios" id="teamRadio" value="team" v-model="userEdit.userCategory"/>
                                                <label class="form-radio" for="teamRadio"><span>{{$t('pr_team')}}</span></label>
                                                </div>
                                            </div>

                                            <div class="col-md-6" v-if="userEdit.userType == 'agent'">
                                                <div class="form-group has-label">
                                                    <input type="radio" name="categoryRadios" id="employerRadio" value="employer" v-model="userEdit.userCategory"/>
                                                    <label class="form-radio" for="employerRadio"><span>{{$t('pr_employer')}}</span></label>
                                                </div>
                                            </div>
                                            <div class="col-md-6" v-if="userEdit.userType == 'agent'">
                                                <div class="form-group has-label">
                                                <input type="radio" name="categoryRadios" id="agentRadio" value="agent" v-model="userEdit.userCategory"/>
                                                <label class="form-radio" for="agentRadio"><span>{{$t('pr_agent')}}</span></label>
                                                </div>
                                            </div>
                                    </div>
                                        <div class="row" v-if="userEdit.userCategory !== 'team'">
                                            <div class="col-md-6">
                                                <div class="form-group has-label">
                                                    <label>
                                                        {{$t('pr_name')}} *
                                                    </label>
                                                    <input aria-describedby="addon-right addon-left" type="text" v-model="userEdit.firstName" :placeholder="$t('pr_placeholder_firstName')" class="form-control" required minlength="2" maxlength="30">
                                                </div>
                                            </div>
                                            <div class="col-md-6">
                                                <div class="form-group has-label">
                                                    <label>
                                                        {{$t('pr_lastname')}}
                                                    </label>
                                                    <input aria-describedby="addon-right addon-left" type="text" v-model="userEdit.lastName" :placeholder="$t('pr_placeholder_lastName')" class="form-control valid" maxlength="30">
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-md-6" v-if="userEdit.userCategory == 'team'">
                                                <div class="form-group has-label">
                                                    <label>
                                                        {{$t('pr_teamname')}} *
                                                    </label>
                                                    <input aria-describedby="addon-right addon-left" type="text" v-model="userEdit.teamName" :placeholder="$t('pr_placeholder_teamName')" class="form-control valid" required minlength="2" maxlength="30">
                                                </div>
                                            </div>
                                            <div class="col-md-6" v-if="userEdit.userCategory == 'team'">
                                                <div class="form-group has-label">
                                                    <label>
                                                        {{$t('pr_persons')}} *
                                                    </label>
                                                    <input aria-describedby="addon-right addon-left" type="text" v-model="userEdit.numberOfPersons" v-on:keypress="isNumber($event)" v-on:paste="isNumber($event)" :placeholder="$t('pr_placeholder_number')" class="form-control valid" minlength="1" maxlength="30">
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row">
                                        <div class="col-md-6">
                                                <div class="form-group has-label">
                                                    <label>
                                                        {{$t('pr_email')}} *
                                                    </label>
                                                    <input v-if="!userEdit.isSocialRegister" aria-describedby="addon-right addon-left" type="email" v-model="userEdit.email" @input="getNickName()" :placeholder="$t('pr_placeholder_email')" :class="['form-control', isEmailValid()]" required minlength="3" maxlength="64" disabled="true">
                                                    <input v-if="userEdit.isSocialRegister" aria-describedby="addon-right addon-left" type="email" v-model="userEdit.email2" @input="getNickName()" :placeholder="$t('pr_placeholder_email')" :class="['form-control', isEmailValid()]" required minlength="3" maxlength="64">
                                                </div>

                                                <div class="form-group has-label">
                                                <input type="checkbox" name="isEmailAllowed" id="isEmailAllowed" v-model="userEdit.isEmailAllowed"/>
                                                <label class="form-radio" for="isEmailAllowed"><span class="settings-radio">{{$t('pr_allow_email')}}</span></label>
                                                </div>
                                        </div>
                                        <div class="col-md-6">
                                                <div class="form-group has-label">
                                                    <label>
                                                        {{$t('pr_phone')}}
                                                    </label>
                                                    <input aria-describedby="addon-right addon-left" type="text" v-model="userEdit.phone1" :placeholder="$t('pr_placeholder_phone')" class="form-control" maxlength="30">
                                                </div>

                                                <div class="form-group has-label">
                                                <input type="checkbox" name="isPhoneAllowed" id="isPhoneAllowed" v-model="userEdit.isPhoneAllowed"/>
                                                <label class="form-radio" for="isPhoneAllowed"><span class="settings-radio">{{$t('pr_allow_phone')}}</span></label>
                                                </div>
                                        </div>
                                        <div class="col-md-4" hidden>
                                                <div class="form-group has-label">
                                                    <label>
                                                        {{$t('pr_username')}} *
                                                    </label>
                                                    <input aria-describedby="addon-right addon-left" type="text" v-model="userEdit.nickName" :placeholder="$t('pr_placeholder_username')" class="form-control valid" minlength="3" maxlength="30">
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-md-12">
                                                <div class="form-group has-label">
                                                    <input type="checkbox" name="isNewsLettersAllowed" id="isNewsLettersAllowed" v-model="userEdit.isNewsLettersAllowed"/>
                                                    <label class="form-radio" for="isNewsLettersAllowed"><span class="settings-radio">{{$t('pr_allow_newsLetters')}}</span></label>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row" v-if="userEdit.userType !== 'agent'">
                                        <div class="col-md-12">
                                            <p class="p-title"><i class="fa fa-id-card-o fa-2x" style="padding-right: 15px;" aria-hidden="true"></i>{{$t('pr_skills_text')}}</p>
                                        </div>
                                        </div>
                                        <select-skills :data="{selectedSkills: userEdit.artistTypesList}" @changed-selected-skills="changeTypesList($event)" v-if="userEdit.userType !== 'agent'"></select-skills>

                                        <div class="row">
                                            <div class="col-md-12" v-if="this.userEdit.showHeightField">
                                                <div class="form-group has-label">
                                                    <label>
                                                        {{$t('pr_height')}}
                                                    </label>
                                                    <input aria-describedby="addon-right addon-left" type="text" v-model="userEdit.height" :placeholder="$t('pr_placeholder_height')" class="form-control valid" minlength="3" maxlength="10">
                                                </div>
                                            </div>
                                            <div class="col-md-6">
                                                <div class="form-group has-label">
                                                    <label>
                                                        {{$t('pr_birth_date')}}
                                                    </label>
                                                    <datepicker :format="dateFormatter" :language="calendarLng()" v-model="userEdit.birthDate" name="dateBirthday" :placeholder="$t('pr_birth_date')"></datepicker>
                                                    <p class="danger" v-if="userEdit.userCategory!=='team' && userEdit.birthDate && !ageIsAllowed">{{$t('pr_finish_registration_age')}}</p>
                                                </div>
                                            </div>

                                            <div class="col-md-6">
                                                <div class="form-group has-label">
                                                    <label for="city">
                                                        {{$t('pr_city')}}
                                                    </label>
                                                    <input ref="autocompleteCity" name="autocompleteCity" id="city" class="form-control" autocomplete="off" 
                                                    :placeholder="$t('pr_placeholder_city')" readonly type="email" 
                                                    onfocus="if (this.hasAttribute('readonly')) {this.removeAttribute('readonly');this.blur();this.focus();};">
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-md-12">
                                                <div class="form-group has-label">
                                                    <label>
                                                        {{$t('pr_aboutme')}}
                                                    </label>
                                                    <div class="un-textarea">
                                                        <textarea :placeholder="$t('pr_placeholder_aboutMe')" type="textarea" v-model="userEdit.aboutMe" autosize="true" rows="5" autocomplete="off" validateevent="true" class="textarea-un-inside textarea-aboutme" maxlength="300"></textarea>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row" v-if="userEdit.userType !== 'agent'">
                                            <div class="col-md-12">
                                                <p class="p-title"><i class="fa fa-umbrella fa-2x" style="padding-right: 15px;" aria-hidden="true"></i>{{$t('pr_props_text')}}</p>
                                            </div>
                                        </div>
                                        <div class="row" v-if="userEdit.userType !== 'agent'">
                                            <div class="col-md-5">
                                                <button class="btn btn-default btn-add btn btn-outline-danger btn-filter btn-filter-alt btn-filter-alt-i btn-filter-m" type="button" @click="modalProps2=true">
                                                <i class="fa fa-angle-double-right"></i>{{$t('myProps')}}
                                                </button>
                                            </div>
                                        </div>
                                        <div class="row" v-if="userEdit.userType !== 'agent'">
                                            <div class="col-md-12">
                                                <!-- <p class="p-title"><i class="fa fa-building fa-2x" style="padding-right: 15px;" aria-hidden="true"></i>{{$t('pr_work_text')}}</p> -->
                                                <p class="p-title"><img style="padding-right: 15px; height: 30px; opacity: 0.8;" src="../assets/img/icons/circus.png"/>{{$t('pr_work_text')}}</p>
                                            </div>
                                        </div>
                                        <div class="row" v-if="userEdit.userType !== 'agent'">
                                            <div class="col-md-5">
                                                <button class="btn btn-default btn-add btn btn-outline-danger btn-filter btn-filter-alt btn-filter-alt-i btn-filter-m" type="button" @click="modalExpiEdit=true">
                                                <i class="fa fa-angle-double-right"></i>{{$t('myWorkExp')}}
                                                </button>
                                            </div>
                                        </div>
                                        <div class="row" v-if="userEdit.userType !== 'agent'">
                                            <div class="col-md-12">
                                                <p class="p-title"><i class="fa fa-graduation-cap fa-2x" style="padding-right: 15px;" aria-hidden="true"></i>{{$t('pr_educ_text')}}</p>
                                            </div>
                                        </div>
                                        <div class="row" v-if="userEdit.userType !== 'agent'">
                                            <div class="col-md-5">
                                                <button class="btn btn-default btn-add btn btn-outline-danger btn-filter btn-filter-alt btn-filter-alt-i btn-filter-m" type="button" @click="modalEducEdit=true">
                                                <i class="fa fa-angle-double-right"></i>{{$t('myEduc')}}
                                                </button>
                                            </div>
                                        </div>
                                        <div class="text-center">
                                            <button v-if="!isUserSending" type="submit" class="btn btn-info btn-fill btn-wd" id="submit-btn" onmousedown="document.getElementById('city').type='text'">
                                                {{$t('pr_update')}}
                                            </button>
                                            <sync-loader v-if="isUserSending" class="text-center" color="red"></sync-loader>
                                        </div>
                                        <div class="clearfix"></div>
                                    </form>
                            </div>
                        </div>
                    </div>

                    <div class="col-lg-4 col-md-5 mobile-container" id="first">
                        <div class="card card-profile">
                            <div class="card-image">
                                <div class="cover-img cover-default"></div>
                            </div>
                            <div class="card-body">
                                <div class="author">
                                <img :src="getProfileImg" alt="" class="avatar border-gray">
                                <h4 class="title">
                                    <span v-if="(userEdit.userCategory == 'artist') || (userEdit.userCategory == 'agent') || (userEdit.userCategory == 'employer')">{{userEdit.firstName}} {{userEdit.lastName}}</span>
                                    <span v-if="userEdit.userCategory == 'team'">{{userEdit.teamName}}</span>
                                    <div>
                                    <small v-if="userEdit.userCategory == 'team'">{{$t('pr_m_circus_team')}}</small>
                                    <small v-if="userEdit.userCategory == 'artist'">{{$t('pr_m_artist')}}</small>
                                    <small v-if="userEdit.userCategory == 'agent'">{{$t('pr_m_agent')}}</small>
                                    <small v-if="userEdit.userCategory == 'employer'">{{$t('pr_m_employer')}}</small>
                                    </div>
                                </h4>
                                </div>
                                <p class="description text-center"><span>{{userEdit.aboutMe}}</span></p>
                                <hr><br>
                            </div>
                        </div>

                        <educ ref="modalEducEdit" :propsList="userEdit.educationList" :modalShow="modalEducEdit" :showButtons="true" @props-update="userEdit.educationList=$event;" @props-close="modalEducEdit=false;saveModalChanges();"></educ>
                        <expi ref="modalExpiEdit" :propsList="userEdit.experienceList" :modalShow="modalExpiEdit" :showButtons="true" @props-update="userEdit.experienceList=$event;" @props-close="modalExpiEdit=false;saveModalChanges();"></expi>
                        <props ref="modalProps2" :propsList="userEdit.propsList" :modalShow="modalProps2" :showButtons="true" @props-update="userEdit.propsList=$event;" @props-close="modalProps2=false;saveModalChanges();"></props>

                        <div class="col-md-12 disable-col-padding">
                        <div class="card card-profile">
                            <div class="card-body card-padding">
                            <div role="tablist">
                                <b-card no-body class="mb-1">
                                <b-card-header header-tag="header" class="p-1" role="tab">
                                    <b-btn block href="#" v-b-toggle.accordion2 variant="default">
                                    <p class="p-title title-collapse">
                                        <span class="step-label"></span> 
                                        <span class="step-text">{{$t('pr_customize_step2')}}</span>
                                    </p>
                                    <i class="fa fa-angle-down chevron-collapse"></i>
                                    </b-btn>
                                </b-card-header>
                                <b-collapse id="accordion2" accordion="my-accordion" role="tabpanel">
                                    <b-card-body class="b-1">
                                    <div class="row">
                                        <div class="col-md-12">
                                        <croppa 
                                            v-model="cropPhoto"
                                            :width="180"
                                            :height="180"
                                            :quality="1"
                                            :placeholder="cropImagePlaceholder"
                                            placeholder-color="#353535"
                                            :placeholder-font-size="14"
                                            canvas-color="white"
                                            :show-remove-button="false"
                                            :show-loading="false"
                                            accept="image/*"
                                            :file-size-limit="35 * 1024 * 1024"
                                            @file-type-mismatch="onFileTypeMismatch"
                                            @file-size-exceed="onFileSizeExceed"
                                            :zoom-speed="10"
                                            prevent-white-space
                                            @init="onInitCropImage"
                                            @file-choose="onFileSelected"
                                            @image-remove="onFileRemoved"
                                            initial-size="cover"
                                            initial-position="center"
                                        >
                                        <div class="spinner" v-if="cropPhoto && cropPhoto.loading"></div>
                                        </croppa>
                                        <div class="text-center" v-if="isCropPhotoLoaded">  
                                            <i class="fa fa-plus crop-btn" @click="cropPhoto.zoomIn()"></i>
                                            <i class="fa fa-minus crop-btn" @click="cropPhoto.zoomOut()"></i>
                                        </div>
                                        <div class="text-center">
                                            <button class="btn btn-default select-btn" @click="cropPhoto.chooseFile()">
                                            <i class="fa fa-folder-open-o"></i> 
                                            {{$t('pr_customize_select')}}</button>
                                            <button class="btn btn-default select-btn" @click="cropPhoto.remove()">
                                            <i class="fa fa-trash-o" aria-hidden="true"></i>
                                            {{$t('pr_customize_remove')}}</button>
                                            <p class="select-text">{{$t('pr_customize_fileSize')}}</p>
                                        </div>
                                        </div>
                                    </div>
                                    </b-card-body>
                                </b-collapse>
                                </b-card>
                            </div>

                            </div>
                        </div>
                        </div>

                        <button v-if="!isUserSending" class="btn btn-danger save-btn" onmousedown="document.getElementById('submit-btn').click()" :hidden="!isChangedProfile"><i class="fa fa-arrow-left" style="margin-right: 7px;"></i>{{$t('pr_update')}}</button>
                        <sync-loader v-if="isUserSending && isChangedProfile" class="save-btn-sync" color="red"></sync-loader>
                    </div>

                </div>

                <div class="row">
                <div class="col-md-12">
                    <div class="text-left">
                    <button v-if="userEdit.isSocialRegister" type="button" class="delete-profile" @click="deleteUserProfile()">{{$t('pr_delete_profile')}}</button>
                    <button v-if="!userEdit.isSocialRegister" type="button" class="delete-profile" @click="confirmDeleteAccount()">{{$t('pr_delete_profile')}}</button>
                    <button v-if="!userEdit.isSocialRegister" type="button" class="delete-profile password" @click="changePassword()">{{$t('pr_change_password')}}</button>
                    <button type="button" class="delete-profile password" @click="showPrivacyPolicy()">{{`${$t('reg_privacy_policy1')} universtage.com`}}</button>
                    </div>
                </div>
                </div>

            </b-tab>

        </b-tabs>

            </div>
        </div>
    </template>
    </side-bar-page>
</template>

<script>
  import Autolinker from 'autolinker';
  import SideBarPage from '../components/SideBarPage';
  import { mapActions, mapGetters} from 'vuex';
  import { USER_IMG_SEND, USER_GALLERY_VIDEO_SEND, USER_GALLERY_VIDEO_LOAD, USER_GALLERY_IMAGES_LIST, 
           USER_GALLERY_IMAGE, USER_AVATAR_LOAD, USER_PROFILE_LOAD, IMAGE_DELETE, VIDEO_DELETE,
           USER_LOAD, USER_SEND, USER_REQUEST, USER_DELETE, AUTH_LOGOUT, AUTH_REQUEST, UPLOADS_SAVE_HASH_TAG } from "../store/actions/userConst";
  import { MESSAGE_ADD } from "../store/actions/messageConst";
  import { GOOGLE_GET_PLACE } from "../store/actions/langConst";
  import syncLoader from 'vue-spinner/src/PulseLoader.vue';
  import swal from 'sweetalert2';
  import gallery from 'gallery-vue';
  import PictureInput from 'vue-picture-input';
  import axios from 'axios';

  import Props from '../components/Props';
  import Educ from '../components/Education';
  import Expi from '../components/Experience';
  import datepicker from 'vuejs-datepicker';
  import {en, ru} from 'vuejs-datepicker/dist/locale';
  import { interval } from 'rxjs'
  import { takeUntil, filter } from 'rxjs/operators'
  import selectSkills from "../components/SelectSkills";
  var moment = require('moment');
  moment().format();

  export default {
    components: { SideBarPage, syncLoader, gallery, PictureInput, Props, datepicker, selectSkills, Educ, Expi },
    watch: {
      '$route'() {
        // обрабатываем изменение параметров маршрута...
        this.loadProfile(); // Запуск отрисовки
      },
    //   'userEdit.birthDate': function(date, oldVal) {
    //       oldVal !== '' ? this.isChangedProfile = true : false;
    //     //   console.log(date);
    //       var today = moment(new Date());
    //       var diff = today.diff(date, 'years');
    //       diff < 13 ? this.ageIsAllowed = false : this.ageIsAllowed = true;
    //   },
    //   'userEdit.firstName': function(newVal, oldVal) {
    //       oldVal !== '' ? this.isChangedProfile = true : false;
    //    },
    //    'userEdit.lastName': function(newVal, oldVal) {
    //       oldVal !== '' ? this.isChangedProfile = true : false;
    //    },
    //    'userEdit.teamName': function(newVal, oldVal) {
    //       oldVal !== '' ? this.isChangedProfile = true : false;
    //    },
    //    'userEdit.numberOfPersons': function(newVal, oldVal) {
    //       oldVal !== '' ? this.isChangedProfile = true : false;
    //    },
    //    'userEdit.isEmailAllowed': function(newVal, oldVal) {
    //       oldVal !== '' ? this.isChangedProfile = true : false;
    //    },
    //    'userEdit.isPhoneAllowed': function(newVal, oldVal) {
    //       oldVal !== '' ? this.isChangedProfile = true : false;
    //    },
    //    'userEdit.isNewsLettersAllowed': function(newVal, oldVal) {
    //         console.log(this.$_.isEqual(this.userEdit,this.getUserProfile));
    //     //    console.log(this.getUserProfile.isNewsLettersAllowed);
    //     //    console.log(newVal);
    //     //   newVal !== this.getUserProfile.isNewsLettersAllowed ? this.isChangedProfile = true : false;
    //     //    console.log(this.isChangedProfile);
    //     // //   oldVal !== '' ? this.isChangedProfile = true : false;
    //    },
    //    'userEdit.phone1': function(newVal, oldVal) {
    //       oldVal !== '' ? this.isChangedProfile = true : false;
    //    },
    //    'userEdit.email': function(newVal, oldVal) {
    //       oldVal !== '' ? this.isChangedProfile = true : false;
    //    },
    //    'userEdit.aboutMe': function(newVal, oldVal) {
    //       oldVal !== '' ? this.isChangedProfile = true : false;
    //    },
    //    'userEdit.userCategory': function(newVal, oldVal) {
    //       oldVal !== '' ? this.isChangedProfile = true : false;
    //    },
    //    'userEdit.height': function(newVal, oldVal) {
    //       oldVal !== '' ? this.isChangedProfile = true : false;
    //    },
    //    'userEdit.educationList': function(newVal, oldVal) {
    //        console.log(oldVal.length);
    //        console.log(newVal.length);
    //       if (oldVal.length !== 0) {
    //     //   if (JSON.stringify(oldVal) !== JSON.stringify(newVal)) {
    //           this.isChangedProfile = true;
    //           this.isChangedEdu = true;
    //       }
    //    },
    //    'userEdit.experienceList': function(newVal, oldVal) {
    //        if (oldVal.length !== 0) {
    //           this.isChangedProfile = true;
    //           this.isChangedExp = true;
    //         }
    //    },
    //    'userEdit.propsList': function(newVal, oldVal) {
    //        if (oldVal.length !== 0 && this.modalProps) {
    //           this.isChangedProfile = true;
    //           this.isChangedProps = true;
    //         }
    //    },
    },
    beforeDestroy() {
      this.RxLngPointer.unsubscribe()
      this.RxGooglePointer.unsubscribe()
    },
    mounted() {
      this.RxLngPointer = this.RxLng.subscribe(()=> {
          this.updateGooglePlace();
          this.updateGooglePlaceEdit();
          this.forcePictureInputUpdate();
      });
      this.RxGooglePointer = this.RxGoogle.subscribe(gPlace=>{
        if(gPlace) {
          let autocomplete = new gPlace.Autocomplete(this.$refs.autocompleteCity, {types: ['(cities)']})
          autocomplete.addListener('place_changed', ()=>{
            let place = autocomplete.getPlace()
            this.userEdit.city = place.address_components[0].long_name;
            this.userEdit.country = place.address_components.filter(ac=>ac.types && ac.types[0]==='country')[0].long_name;
            this.userEdit.googlePlace = place.place_id;
         })
        }
      });
        this.$root.$on('bv::modal::shown', () => {
        if (this.showUploadImageModal) {
            this.$nextTick(function () {
                // DOM updated
                window.dispatchEvent(new Event('resize'));
            });
        }
    });
    },
    created() {
        !this.isLogin ? this.loadProfile() : false;
        const obs = interval(100);
        obs.pipe(takeUntil(obs.pipe(filter(val => {
            if(this.getUserProfile.id) {
                this.userEdit = JSON.parse(JSON.stringify(this.getUserProfile));
                this.updateGooglePlaceEdit()
                this.loadProfile();
                this.showAgreementModal = !this.userEdit.isAgreementAccepted;
                this.getNickName();
                return true
            } else {
                if(val>300) {
                console.log('time out 30s. for load profile')
                return true
                }
            }
        })))).subscribe(()=>{});
    },
    data(){
      return {
        inputOver: false,
        modalExpiEdit: false,
        modalEducEdit: false,
        modalProps: false,
        showMessageModal: false,
        showUploadImageModal: false,
        showUploadVideoModal: false,
        showDeleteVideoModal: false,
        showDeleteImageModal: false,

        isCollapse: false,
        isCollapseEdu: false,
        isCollapseExp: false,
        profilePhoto: {},
        galleryImageObject: null,
        galleryImgBase64: null,
        uploadedImgTitle: '',
        video: {
            title: '',
            href: '',
            poster: '',
            youtube: '',
            media: 'youtube'
        },
        user: {
            firstName: '',
            lastName: '',
            city: '',
            country: '',
            phone1: '',
            email: '',
            nickName: '',
            teamName: '',
            numberOfPersons: '',
            aboutMe: '',
            accountType: '',
            educationList: [],
            experienceList: [],
            artistTypesList: []
        },
        images: [],
        imagesList: [],
        videos: [],
        index: null,
        indexVideo: null,
        jsonVimeo: null,
        stringsPictureInput: {
            upload: this.$t('pr_upload_not_support'),
            drag: this.$t('pr_drag_drop_file'),
            change: this.$t('pr_upload_change'), 
            remove: this.$t('pr_upload_delete'),
            fileSize: this.$t('pr_big_file'),
            fileType: this.$t('pr_invalid_file'),
            tap: this.$t('pr_tap'),
        },
        imageCompressLevel: 0.7, // 70% quality
        toast: swal.mixin({
                toast: true,
                position: 'bottom-start',
                customClass: 'sweet-modal',
                showConfirmButton: false,
                timer: 5000
        }),
        toast_top: swal.mixin({
                toast: true,
                position: 'top-start',
                customClass: 'sweet-modal',
                showConfirmButton: false,
                timer: 5000
        }),
        newMessage: '',

        countriesList: [],
        selectArtistType: null,
        selectArtistCategories: null,
        selectArtistSkill: null,
        cropPhoto: {},
        isCropPhotoLoaded: false,
        showImageProfile: false,
        showImageCover: false,
        showAgreementModal: false,
        showPasswordModal: false,
        blobImageCover: Object,
        coverFiles: this.$t('pr_no_file'),
        regexEmail: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/,
        // isChangedProfile: false,
        ageIsAllowed: false,
        RxLngPointer: null,
        RxGooglePointer: null,
        modalProps2: false,
        userEdit: {
            firstName: '',
            lastName: '',
            city: '',
            country: '',
            phone1: '',
            email: '',
            nickName: '',
            teamName: '',
            numberOfPersons: '',
            aboutMe: '',
            isEmailAllowed: '',
            isPhoneAllowed: '',
            isNewsLettersAllowed: '',
            birthDate: '',
            height: '',
            propsList: [],
            artistTypesList: [],
            educationList: [],
            experienceList: [],
            userType: 'artist',
            userCategory: '',
            googlePlace: null,
        },
        checkPass: {},
      }
    },
    computed: {
        ...mapGetters(['isAdmin', 'isMobileResolution', 'currentLng', 'isLogin', 'isUploadingImgGallery', 'isUploadingVideoGallery', 'isDeletingVideoGallery', 'isDeletingImageGallery', 'getUserProfile', 'getProfileImg', 'RxLng', 'RxGoogle', 'isUserSending', 'getAccessToken','getSkills','getArtistTypes']),
        cropImagePlaceholder() {
            return this.cropPhoto && this.cropPhoto.loading ? '' : this.$t('pr_drop_file')
        },
        isChangedProfile() {
            // console.log(this.userEdit.isNewsLettersAllowed,this.getUserProfile.isNewsLettersAllowed);
            return !this.$_.isEqual(this.userEdit,this.getUserProfile);
            // return this.userEdit.isNewsLettersAllowed !== this.getUserProfile.isNewsLettersAllowed;
        },
        aboutMeHtml() {
            let autolinker = new Autolinker();
            return autolinker.link(this.user.aboutMe);
        },
    },
    methods: {
        ...mapActions([USER_IMG_SEND, USER_GALLERY_VIDEO_SEND, USER_GALLERY_VIDEO_LOAD, 
                        USER_GALLERY_IMAGES_LIST, USER_GALLERY_IMAGE, USER_AVATAR_LOAD, USER_PROFILE_LOAD, IMAGE_DELETE, 
                        VIDEO_DELETE,GOOGLE_GET_PLACE,MESSAGE_ADD, USER_LOAD, USER_SEND, USER_DELETE, AUTH_LOGOUT, UPLOADS_SAVE_HASH_TAG]),
        test() {
            console.log(this.isMobileResolution);
        },
        saveHashTag(video) {
            this.UPLOADS_SAVE_HASH_TAG({id: video.id, data: {hashTag: video.hashTag}})
                .then(res=>{
                    delete video.hashTagEdit;
                    this.videos.push({})
                    this.videos.splice(this.videos.length-1,1)
                })
                .catch(err=>console.log(err));
        },
        prepareSEO() {
            if (!this.isLogin) {
                let name;
                if (this.user.userCategory === 'team') {
                    type = this.$t('pr_m_circus_team')
                } else if (this.user.userCategory === 'artist') {
                    type = this.$t('pr_m_artist')
                } else if (this.user.userCategory === 'agent') {
                    type = this.$t('pr_m_agent')
                } else if (this.user.userCategory === 'employer') {
                    type = this.$t('pr_m_employer')
                }
                let type;
                if (this.user.userCategory !== 'team') {
                    name = this.user.firstName + ' ' + this.user.lastName
                } else {
                    name = this.user.teamName
                }
                let artistType;
                try {
                 artistType = this.getArtistType(this.user.artistTypesList[0].artistTypeId)['type_'+this.currentLng];   
                } catch (error) {}
                let isExist = (typeof artistType !== 'undefined') ? true : false;
                let description = 
                `${type.charAt(0).toUpperCase()}${type.substring(1)} ${name} on our social network. Find jobs for ${isExist ? artistType.toLowerCase() : 'artists'} here. Find employees for circus show or performance`;
                document.querySelector("meta[name='description']").setAttribute('content', description);
                let title = `Find ${isExist ? artistType.toLowerCase() : 'circus'} jobs | Hire ${isExist ? artistType.toLowerCase() : 'employees'} for performance`
                document.querySelector("title").text = title;
            }
        },
        loadProfile() {
            this.USER_AVATAR_LOAD({
                id: this.$route.params.id
            }).then(res=> {
                this.profilePhoto = res;
            }).catch(err=>console.log(err));
            this.USER_PROFILE_LOAD({
                id: this.$route.params.id
            }).then(res=> {
                this.user = res;
                this.prepareSEO();
                this.updateGooglePlace()
            }).catch(err=>console.log(err));
            this.USER_GALLERY_IMAGES_LIST({
                id: this.$route.params.id
            }).then(res=> {
                this.imagesList = res;
                this.images = [];
                // console.log(this.imagesList);
                if (this.imagesList && (typeof this.imagesList !== 'undefined')) {
                    this.imagesList.forEach(image => {
                        this.USER_GALLERY_IMAGE({
                            id: image.id
                        }).then(res=> {
                            if(res.success) {
                                this.validateImage(res.data.href).then(valid => {
                                    if (valid) {
                                        this.images.push(res.data);
                                    }
                                });
                            } else {
                                console.log('Error get image ' + this.imagesList[0].id);
                            }
                        }).catch(err=>console.log(err)); 
                    });
                }
            }).catch(err=>console.log(err));
            this.USER_GALLERY_VIDEO_LOAD({
                id: this.$route.params.id
            }).then(res=> {
                if (res.successful) {
                    this.videos = res.data;
                    // console.log('videos');
                    // console.log(this.videos);
                } else {
                    this.videos = [];
                }
            }).catch(err=>console.log(err));
        },
        updateGooglePlace() {
            let promiseArray = [];
            if(this.user && this.user.googlePlace && !(this.user.googlePlaceLocales && this.user.googlePlaceLocales[this.currentLng])) {
                promiseArray.push(
                    this.GOOGLE_GET_PLACE({place_id: this.user.googlePlace, language: this.currentLng, fields: ['address_components']})
                        .then(place=>{
                            this.user.googlePlaceLocales = this.user.googlePlaceLocales || {}
                            this.user.googlePlaceLocales[this.currentLng] = {}
                            this.user.googlePlaceLocales[this.currentLng].city = place.address_components[0].long_name
                            this.user.googlePlaceLocales[this.currentLng].country = place.address_components.filter(ac=>ac.types && ac.types[0]==='country')[0].long_name
                        })
                        .catch(err=>console.log(err))
                );
            }
            if(this.user && this.user.educationList && this.user.educationList.length) {
                this.user.educationList.forEach(element=>{
                    if(element.googlePlace) {
                        if(!(element.googlePlaceLocales && element.googlePlaceLocales[this.currentLng])) {
                            promiseArray.push(
                                this.GOOGLE_GET_PLACE({place_id: element.googlePlace, language: this.currentLng, fields: ['name']})
                                    .then(place=>{
                                    element.googlePlaceLocales = element.googlePlaceLocales || {};
                                    element.googlePlaceLocales[this.currentLng] = place.name;
                                    element.name = place.name;
                                    })
                                    .catch(err=>console.log(err))
                            );
                        } else {
                            element.name = element.googlePlaceLocales[this.currentLng];   
                        }
                    }
                });
            }
            if(this.user && this.user.experienceList && this.user.experienceList.length) {
                this.user.experienceList.forEach(element=>{
                    if(element.googlePlace) {
                        if(!(element.googlePlaceLocales && element.googlePlaceLocales[this.currentLng])) {
                            promiseArray.push(
                                this.GOOGLE_GET_PLACE({place_id: element.googlePlace, language: this.currentLng, fields: ['name']})
                                    .then(place=>{
                                    element.googlePlaceLocales = element.googlePlaceLocales || {};
                                    element.googlePlaceLocales[this.currentLng] = place.name;
                                    element.name = place.name;
                                    })
                                    .catch(err=>console.log(err))
                            );
                        } else {
                            element.name = element.googlePlaceLocales[this.currentLng];   
                        }
                    }
                });
            }
            if(promiseArray.length) {
                Promise.all(promiseArray)
                    .then(()=>{
                        this.user = JSON.parse(JSON.stringify(this.user)) // хук! Без этой фигни не обновляло экран 
                    })
                    .catch(err=>console.log(err))
            } else {
                this.user = JSON.parse(JSON.stringify(this.user)) // хук! Без этой фигни не обновляло экран
            }
        },
        // updateGooglePlace() {
        //     if(this.user && this.user.googlePlace && !(this.user.googlePlaceLocales && this.user.googlePlaceLocales[this.currentLng])) {
        //         this.GOOGLE_GET_PLACE({place_id: this.user.googlePlace, language: this.currentLng, fields: ['address_components']})
        //             .then(place=>{
        //                 this.user.googlePlaceLocales = this.user.googlePlaceLocales || {}
        //                 this.user.googlePlaceLocales[this.currentLng] = {}
        //                 this.user.googlePlaceLocales[this.currentLng].city = place.address_components[0].long_name
        //                 this.user.googlePlaceLocales[this.currentLng].country = place.address_components.filter(ac=>ac.types && ac.types[0]==='country')[0].long_name
        //                 // this.user.googlePlaceLocales[this.currentLng].country = place.address_components[place.address_components.length - 1].long_name
        //                 if(this.user && this.user.educationList && this.user.educationList.length) {
        //                     let promiseArray = []
        //                     this.user.educationList.forEach(element=>{
        //                         if(element.googlePlace) {
        //                             if(!(element.googlePlaceLocales && element.googlePlaceLocales[this.currentLng])) {
        //                                 promiseArray.push(
        //                                     this.GOOGLE_GET_PLACE({place_id: element.googlePlace, language: this.currentLng, fields: ['name']})
        //                                         .then(place=>{
        //                                         element.googlePlaceLocales = element.googlePlaceLocales || {};
        //                                         element.googlePlaceLocales[this.currentLng] = place.name;
        //                                         element.name = place.name;
        //                                         // console.log(place.name);
        //                                         // this.user.educationList.push({});
        //                                         // this.user.educationList.splice(this.user.educationList.length-1,1);
        //                                         })
        //                                         .catch(err=>console.log(err))
        //                                 );
        //                             } else {
        //                                 element.name = element.googlePlaceLocales[this.currentLng];   
        //                                 // this.user.educationList.push({});
        //                                 // this.user.educationList.splice(this.user.educationList.length-1,1);
        //                             }
        //                         }
        //                     });
        //                     if(promiseArray.length) {
        //                         Promise.all(promiseArray)
        //                             .then(()=>{
        //                                 this.user = JSON.parse(JSON.stringify(this.user)) // хук! Без этой фигни не обновляло экран 
        //                             })
        //                             .catch(err=>console.log(err))
        //                     } else {
        //                         this.user = JSON.parse(JSON.stringify(this.user)) // хук! Без этой фигни не обновляло экран
        //                     }
        //                 } else {
        //                   this.user = JSON.parse(JSON.stringify(this.user)) // хук! Без этой фигни не обновляло экран
        //                 }
        //             })
        //             .catch(err=>console.log(err))
        //     }
        // },
        updateGooglePlaceEdit() {
        if(this.userEdit && this.userEdit.googlePlace && !(this.userEdit.googlePlaceLocales && this.userEdit.googlePlaceLocales[this.currentLng])) {
          this.GOOGLE_GET_PLACE({place_id: this.userEdit.googlePlace, language: this.currentLng, fields: ['address_components']})
            .then(place=>{
              this.userEdit.googlePlaceLocales = this.userEdit.googlePlaceLocales || {}
              this.userEdit.googlePlaceLocales[this.currentLng] = place.address_components[0].long_name + ', ' + place.address_components.filter(ac=>ac.types && ac.types[0]==='country')[0].long_name
              this.$refs.autocompleteCity.value = this.userEdit.googlePlaceLocales[this.currentLng]
            })
            .catch(err=>console.log(err))
        } else {
          if(this.userEdit.googlePlaceLocales && this.userEdit.googlePlaceLocales[this.currentLng]) {
            this.$refs.autocompleteCity.value = this.userEdit.googlePlaceLocales[this.currentLng]
          }
        }
      },
        writeMessage() {
            this.showMessageModal = !this.showMessageModal;
        },
        uploadImages() {
            this.$refs.pictureInput.removeImage();
            this.showUploadImageModal = !this.showUploadImageModal;
        },
        uploadVideos() {
            this.showUploadVideoModal = !this.showUploadVideoModal;
        },
        deleteVideos() {
            if (this.videos.length > 0) {
                this.showDeleteVideoModal = !this.showDeleteVideoModal;
            } else {
                this.toast.fire({
                    title: '<i class="fa fa-exclamation fa-2x"></i>' + this.$t('pr_m_gallery_no_videos')
                });
            }
        },
        deleteImages() {
            if (this.images.length > 0) {
                this.showDeleteImageModal = !this.showDeleteImageModal;
            } else {
                this.toast.fire({
                    title: '<i class="fa fa-exclamation fa-2x"></i>' + this.$t('pr_m_gallery_no_images')
                });
            }
        },
        sendMessage(id) {
            if (this.newMessage.length > 0) {
                this.MESSAGE_ADD({
                    adressedToId: id,
                    text: this.newMessage
                }).then(() => {
                    this.newMessage = '';
                    this.showMessageModal = false;
                }).catch((err)=> {
                    console.log(err);
                    this.toast.fire({
                        title: '<i class="fa fa-times fa-2x"></i>' + this.$t('hpf_err_unknown')
                    });
                });
            }
        },
        collapseSkills() {
            this.isCollapse = !this.isCollapse;
        },
        range(start, end, arr) {
            if(typeof arr !== 'undefined') {
                return arr.slice(start, end);
            } else {
                return false;
            }
        },
        getArtistType(artistId) {
            let result = this.getArtistTypes.find(t => t.id === artistId);
            if ((typeof result !== 'undefined') && result) {
                return result;
            } else {
                return 'error';
            }
        },
        getCategory(artistId, categoryId) {
            let artistType = this.getArtistTypes.find(t => t.id === artistId);
            let category = artistType.categories.find(a => a.name_en === categoryId);
            if ((typeof category !== 'undefined') && category) {
                return category;
            } else {
                return 'error';
            }
        },
        getSkill(skillId) {
            if (Array.isArray(this.getSkills)) {
                let result = this.getSkills.find(s => s.code === skillId);
                if ((typeof result !== 'undefined') && result) {
                    return result;
                } else {
                    return 'error';
                }
            }
        },
        onUploadImgError(e) {
            console.log(e);
            this.toast.fire({
                title: '<i class="fa fa-times fa-2x"></i>' + e.message
            });
        },
        postGalleryImage() {
            if (this.galleryImageObject) {
                console.log(this.galleryImageObject);
                this.USER_IMG_SEND({
                    image: this.galleryImageObject,
                    title: this.uploadedImgTitle || ' ',
                    mediaType: 'image'
                }).then((res)=>{
                    console.log('res');
                    console.log(res);
                    if (res.data.result === 'limit') {
                        this.toast.fire({
                            title: '<i class="fa fa-exclamation fa-2x"></i>' + this.$t('pr_m_gallery_limit')
                        });
                    } else {
                        this.images.push({id: res.data.result, href: this.galleryImgBase64, title: this.uploadedImgTitle || ' '});
                        this.toast.fire({
                            title: '<i class="fa fa-check fa-2x"></i>' + this.$t('pr_m_gallery_uploaded')
                        });
                        this.showUploadImageModal = false;
                        this.uploadedImgTitle = '';
                    }
                    this.galleryImageObject = null;
                    this.galleryImgBase64 = null;
                })
                .catch((err)=> {
                    this.showUploadImageModal = false;
                    const code = this.$ObjValidate(() => err.response.data.error.code) ? err.response.data.error.code : '';
                    if (code === 'UPLOAD_IMAGE_LIMIT') {
                        this.toast.fire({
                                title: '<i class="fa fa-exclamation fa-2x"></i>' + this.$t('pr_photo_limit', {limit: this.getUserProfile.photoLimit})
                            });
                    } else if (code === 'FILE_FORMAT') {
                        this.toast.fire({
                            title: '<i class="fa fa-times fa-2x"></i>' + this.$t('up_err_filetype')
                        });
                    } else {
                        this.toast.fire({
                            title: '<i class="fa fa-times fa-2x"></i>' + this.$t('pr_m_gallery_not_uploaded')
                        });
                    }
                    this.galleryImageObject = null;
                    this.galleryImgBase64 = null;
                });
            }
        },
        postGalleryVideo() {
            // if youtube video
            if (this.video.media === 'youtube') {
                this.video.href = this.video.href.replace(/\s/g,'');
                let state = this.video.href.includes("youtu");
                if (state) {
                    // long youtube link from uri
                    let index = this.video.href.indexOf('?');
                    if (index !== -1) {
                        this.video.youtube = this.video.href.substring(index+3, this.video.href.length);
                    } else {
                        // short youtu.be link
                        let index = this.video.href.indexOf('e/');
                        if (index !== -1) {
                            this.video.youtube = this.video.href.substring(index+2, this.video.href.length);
                        }
                    }
                    this.video.poster = 'https://img.youtube.com/vi/'+ this.video.youtube +'/maxresdefault.jpg'
                    this.USER_GALLERY_VIDEO_SEND({
                        href: this.video.href,
                        title: this.video.title || ' ',
                        poster: this.video.poster,
                        youtube: this.video.youtube,
                    }).then((res) => {
                        this.videos.push({
                            id: res.data.result,
                            href: this.video.href,
                            title: this.video.title || ' ',
                            poster: this.video.poster,
                            youtube: this.video.youtube,
                            media: "youtube",
                            type: "text/html"
                        });
                        this.toast.fire({
                            title: '<i class="fa fa-check fa-2x"></i>' + this.$t('pr_m_gallery_video_uploaded')
                        });
                        this.showUploadVideoModal = false;
                        this.video.title = '';
                        this.video.href = '';
                    }).catch((err)=> {
                        console.log(err);
                        const code = this.$ObjValidate(() => err.response.data.error.code) ? err.response.data.error.code : '';
                        if (code === 'UPLOAD_VIDEO_LIMIT') {
                            this.toast.fire({
                                title: '<i class="fa fa-times fa-2x"></i>' + this.$t('pr_m_gallery_video_limit')
                            });
                        } else {
                            this.toast.fire({
                                title: '<i class="fa fa-times fa-2x"></i>' + this.$t('pr_m_gallery_video_not_uploaded')
                            });
                        }
                        this.showUploadVideoModal = false;
                        this.video.title = '';
                        this.video.href = '';
                    });
                } else {
                    this.toast.fire({
                        title: '<i class="fa fa-times fa-2x"></i>' + this.$t('pr_youtube_link_err')
                    });
                    this.video.title = '';
                    this.video.href = '';
                }
            } else if (this.video.media === 'vimeo') {
                // if vimeo video
                this.video.href = this.video.href.replace(/\s/g,'');
                let state = this.video.href.includes("vimeo");
                if (state) {
                    let index = this.video.href.indexOf('m/');
                    if (index !== -1) {
                        this.video.vimeo = this.video.href.substring(index+2, this.video.href.length);
                    }
                    axios.get('https://vimeo.com/api/v2/video/' + this.video.vimeo + '.json?callback=showThumb')
                    .then(response => {
                        this.jsonVimeo = response.data;
                        let firstIndex = this.jsonVimeo.indexOf('thumbnail_medium');
                        let secondIndex = this.jsonVimeo.indexOf('thumbnail_large');
                        if ((firstIndex !== -1) && (secondIndex !== -1)) {
                            var tmpStr = this.jsonVimeo.substring(firstIndex+19, secondIndex);
                            var thirdIndex = tmpStr.indexOf('video');
                            if(thirdIndex !== -1) {
                                var thumbnail = tmpStr.substring(thirdIndex+7,tmpStr.length-15);
                                this.video.poster = 'https://i.vimeocdn.com/video/' + thumbnail + '_1280.jpg';
                            }
                        }
                        this.USER_GALLERY_VIDEO_SEND({
                            href: this.video.href,
                            title: this.video.title || ' ',
                            poster: this.video.poster,
                            vimeo: this.video.vimeo,
                        }).then((res) => {
                            this.videos.push({
                                id: res.data.result,
                                href: this.video.href,
                                title: this.video.title || ' ',
                                poster: this.video.poster,
                                vimeo: this.video.vimeo,
                                media: "vimeo",
                                type: "text/html"
                            });
                            this.toast.fire({
                                title: '<i class="fa fa-check fa-2x"></i>' + this.$t('pr_m_gallery_video_uploaded')
                            });
                            this.showUploadVideoModal = false;
                            this.video.title = '';
                            this.video.href = '';
                        }).catch((err)=> {
                            console.log(err);
                            this.toast.fire({
                                title: '<i class="fa fa-times fa-2x"></i>' + this.$t('pr_m_gallery_video_not_uploaded')
                            });
                            this.showUploadVideoModal = false;
                            this.video.title = '';
                            this.video.href = '';
                        });
                    }).catch(error => console.log(error));
                } else {
                    this.toast.fire({
                        title: '<i class="fa fa-times fa-2x"></i>' + this.$t('pr_vimeo_link_err')
                    });
                    this.video.title = '';
                    this.video.href = '';
                }
            }
        },
        deleteVideoGallery(index) {
            this.VIDEO_DELETE(this.videos[index]).then(()=> {
                this.videos.splice(index, 1);
                this.videos.length < 1 ? this.showDeleteVideoModal = false : false;
            }).catch((err)=> {
              console.log(err);
            });    
        },
        deleteImageGallery(index) {
            this.IMAGE_DELETE(this.images[index]).then(()=> {
              this.images.splice(index, 1);
              this.images.length < 1 ? this.showDeleteImageModal = false : false;
            }).catch((err)=> {
              console.log(err);
            });    
        },
        onUploadImgChange () {
            if (this.$refs.pictureInput.image) {
                this.galleryImageObject = this.$refs.pictureInput.file;
                this.galleryImgBase64 = this.$refs.pictureInput.image;
            } else {
                console.log('FileReader API not supported: use the <form>')
            }
        },
        forcePictureInputUpdate() {
            this.$refs.pictureInput.strings = {
                upload: this.$t('pr_upload_not_support'),
                drag: this.$t('pr_drag_drop_file'),
                change: this.$t('pr_upload_change'), 
                remove: this.$t('pr_upload_delete'),
                fileSize: this.$t('pr_big_file'),
                fileType: this.$t('pr_invalid_file'),
                tap: this.$t('pr_tap'),
            };
        },
        validateImage(base64) {
            return new Promise((resolve, reject) => {
                var image = document.createElement('img');
                try {
                    image.src = base64;
                    image.onload = () => {
                        var canvas = document.createElement('canvas');
                        canvas.getContext('2d');
                        resolve(true);
                    }
                } catch (error) {
                    reject(false);
                }
            });
        },
        calendarLng() {
        if (this.currentLng === 'ru') {
          return ru;
        } else if (this.currentLng === 'en') {
          return en;
        }
      },
      dateFormatter(date) {
        return moment(date).format('MM-DD-YYYY');
      },
      setPlace(place) {
        this.userEdit.city = place.address_components[0].long_name;
        this.userEdit.country = place.address_components.filter(ac=>ac.types && ac.types[0]==='country')[0].long_name;
        this.userEdit.googlePlace = place.place_id;
      },
      setCountry(place) {
        this.userEdit.country = place;
      },
      onFileTypeMismatch () {
        this.coverFiles = this.$t('pr_no_file');
        this.toast.fire({
          title: '<i class="fa fa-times fa-2x"></i>' + this.$t('pr_invalid_file')
        });
      },
      onFileSizeExceed () {
        this.coverFiles = this.$t('pr_no_file');
        this.toast.fire({
          title: '<i class="fa fa-times fa-2x"></i>' + this.$t('pr_big_file')
        });
      },
      onInitCropImage() {
        this.cropPhoto.addClipPlugin(function (ctx, x, y, w, h) {
          ctx.beginPath()
          ctx.arc(x + w / 2, y + h / 2, w / 2, 0, 2 * Math.PI, true)
          ctx.closePath()
        })  
      },
      onFileSelected() {
        this.isCropPhotoLoaded = true;
      },
      onFileRemoved() {
        this.isCropPhotoLoaded = false;
      },
      isNumber(evt) {
        if (evt.type === 'paste') {
          evt.preventDefault();
        }
        evt = (evt) ? evt : window.event;
        var charCode = (evt.which) ? evt.which : evt.keyCode;
        if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
          evt.preventDefault();
        } else {
          return true;
        }
      },
      isEmailValid() {
        return (this.userEdit.email == "") ? "" : (this.regexEmail.test(this.userEdit.email)) ? 'has-success' : 'has-error';
      },
      submitAgreementModal() {
        if (this.userEdit.isAgreementAccepted) {
          // default selection for user (left checkbox)
          if (this.userEdit.userType === 'artist') {
            this.userEdit.userCategory = 'artist';
          } else if (this.userEdit.userType === 'agent') {
            this.userEdit.userCategory = 'employer';
          }
          this.updateUserProfile();
        }
      },
      updateUserProfile() {
        this.$refs.autocompleteCity.type = 'email';
        if(this.userEdit.propsList && this.userEdit.propsList.length) {
          this.userEdit.propsList.forEach(p => {
              p.height = Number(p.height);
              p.length = Number(p.length);
              p.weight = Number(p.weight);
              p.width = Number(p.width);
          });
          if(this.userEdit.propsList.filter(p=>p.photos.filter(ph=>ph.file).length).length) {
            let count = 0
            let maxCount = 0
            this.userEdit.propsList.forEach(p => {
              if(p.photos && p.photos.length) {
                for (let index = 0; index < p.photos.length; index++) {
                  const ph = p.photos[index];
                  if(ph.file) {
                    maxCount++
                    this.USER_IMG_SEND({
                      image: ph.file,
                      mediaType: 'image-props',
                      maxResolution: 640,
                      quality: 0.6
                    })
                    .then(res => {
                      count++
                      ph.photoId = res.data.result
                      delete ph.file
                      if(count>=maxCount) this.updateUserProfileSecondStep()
                    })
                    .catch(err => {
                      count++
                      console.log(err)
                      p.photos.splice(index,1)
                      if(count>=maxCount) this.updateUserProfileSecondStep()
                    })
                  }
                }
              }
            });
          } else {
            this.updateUserProfileSecondStep()
          }
        } else {
          this.updateUserProfileSecondStep()
        }
        // this.isChangedProfile = false;
      },
      updateUserProfileSecondStep() {
        if(this.userEdit.isAgreementAccepted) {
          this.cropPhoto.generateBlob((blob) => {
            if (blob) {
              this.USER_IMG_SEND({
                image: blob,
                mediaType: 'image-avatar'
              }).then((res)=>{
                  this.toast.fire({
                    title: '<i class="fa fa-check fa-2x"></i>' + this.$t('pr_avatar_uploaded')
                  });
                  if ((this.$refs.autocompleteCity.value === '') || (!this.$refs.autocompleteCity.value) || (typeof this.$refs.autocompleteCity.value === 'undefined')) {
                    this.userEdit.city = null;
                    this.userEdit.googlePlace = null;
                    this.userEdit.country = null;
                    this.userEdit.googlePlaceLocales = null;
                  }
                  // don't need store this data
                  delete this.userEdit.maxFreePhoto;
                  delete this.userEdit.maxFreePosts;
                  delete this.userEdit.maxPhoto;
                  delete this.userEdit.maxPosts;
                  delete this.userEdit.maxProps;
                  delete this.userEdit.photoLimit;
                  delete this.userEdit.postsLimit;
                  delete this.userEdit.propsLimit;
                  this.userEdit.educationList.forEach(e=>{
                    delete e.autocomplete;
                    delete e.googlePlaceLocales;
                    if(e.googlePlace) delete e.name;
                  });
                  this.userEdit.experienceList.forEach(e=>{
                    delete e.autocomplete;
                    delete e.googlePlaceLocales;
                    if(e.googlePlace) delete e.name;
                  });
                  // delete this.userEdit.showHeightField;
                  this.USER_SEND({
                    id: this.getUserProfile.id,
                    user: Object.assign(this.userEdit, { profilePicture: res.data.result }) // save avatar id
                  }).then(()=> {
                      this.loadProfile();
                    this.$store.dispatch(USER_REQUEST)
                    .then((resp)=>console.log(resp))
                    .catch((err)=>console.log(err));
                    this.showAgreementModal = false;
                    this.isMobileResolution ? 
                        this.toast_top.fire({
                        title: '<i class="fa fa-check fa-2x"></i>' + this.$t('pr_successfully_saved')
                        }) :
                        this.toast.fire({
                        title: '<i class="fa fa-check fa-2x"></i>' + this.$t('pr_successfully_saved')
                        });
                  })
                  .catch((err)=> {
                    console.log(err);
                    this.toast.fire({
                      title: '<i class="fa fa-times fa-2x"></i>' + this.$t('pr_not_saved')
                    });
                  });
              })
              .catch(()=> {
                this.toast.fire({
                  title: '<i class="fa fa-times fa-2x"></i>' + this.$t('pr_avatar_not_uploaded')
                });
              });
            } else {
                if ((this.$refs.autocompleteCity.value === '') || (!this.$refs.autocompleteCity.value) || (typeof this.$refs.autocompleteCity.value === 'undefined')) {
                  this.userEdit.city = null;
                  this.userEdit.googlePlace = null;
                  this.userEdit.country = null;
                  this.userEdit.googlePlaceLocales = null;
                }
                // don't need store this data
                delete this.userEdit.maxFreePhoto;
                delete this.userEdit.maxFreePosts;
                delete this.userEdit.maxPhoto;
                delete this.userEdit.maxPosts;
                delete this.userEdit.maxProps;
                delete this.userEdit.photoLimit;
                delete this.userEdit.postsLimit;
                delete this.userEdit.propsLimit;
                this.userEdit.educationList.forEach(e=>{
                  delete e.autocomplete;
                  delete e.googlePlaceLocales;
                  if(e.googlePlace) delete e.name;
                });
                  this.userEdit.experienceList.forEach(e=>{
                    delete e.autocomplete;
                    delete e.googlePlaceLocales;
                    if(e.googlePlace) delete e.name;
                  });
                // delete this.userEdit.showHeightField;
                this.USER_SEND({
                  id: this.getUserProfile.id,
                  user: this.userEdit
                }).then(()=> {
                    this.loadProfile();
                    this.showAgreementModal = false;
                    this.isMobileResolution ?
                        this.toast_top.fire({
                        title: '<i class="fa fa-check fa-2x"></i>' + this.$t('pr_successfully_saved')
                        }) :
                        this.toast.fire({
                        title: '<i class="fa fa-check fa-2x"></i>' + this.$t('pr_successfully_saved')
                        });
                  })
                  .catch(()=> {
                    this.toast.fire({
                      title: '<i class="fa fa-times fa-2x"></i>' + this.$t('pr_not_saved')
                    });
                  });
            }
          }, 'image/png', 1);
        }
      },
      confirmDeleteAccount() {
        this.showPasswordModal = true;
      },
      checkPassword() {
        this.$store.dispatch(AUTH_REQUEST, Object.assign(this.checkPass, {email: this.getUserProfile.email, checkRecaptcha: false}))
          .then(resp => {
            console.log(resp);
            this.showPasswordModal = false;
            this.deleteUserProfile();
          })
          .catch(err => {
            console.log(err)
            const code = this.$ObjValidate(() => err.response.data.error.code) ? err.response.data.error.code : '';
            switch (code) {
              case 'LOGIN_FAILED_EMAIL_NOT_VERIFIED':
                swal({
                  type: 'error',
                  text: this.$t('text15'),
                  keydownListenerCapture: true,
                  allowOutsideClick: false
                })
                break
              case 'LOGIN_FAILED':
                swal({
                  type: 'error',
                  text: this.$t('loginIncorrect'),
                  keydownListenerCapture: true,
                  allowOutsideClick: false
                })
                break
              default:
                swal({
                  type: 'error',
                  text: this.$t('text16'),
                  keydownListenerCapture: true,
                  allowOutsideClick: false
                })
                break
            }
          });
      },
      cancelDeleteAccount() {
        this.showPasswordModal = false;
      },
      deleteUserProfile() {
        swal.fire({
          title: this.$t('pr_delete_profile_question'),
          text: this.$t('pr_delete_profile_txt'),
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#FB404B',
          confirmButtonText: this.$t('pr_delete_ok'),
          cancelButtonText: this.$t('pr_delete_cancel'),
          cancelButtonClass: 'profile-delete-cancel'
        }).then((result) => {
          if (result.value) {
            this.USER_DELETE().then((res)=> {
              console.log(res);
              swal.fire({
                title: this.$t('pr_delete_successfull_header'),
                text: this.$t('pr_delete_successfull_txt'),
                type: 'success',
              }).then(() => {
                this.$store.dispatch(AUTH_LOGOUT);
                this.$router.push({name: 'home'});
              });
            })
            .catch((err)=> {
              console.log(err);
              swal.fire({
                title: this.$t('pr_delete_error_header'),
                text: this.$t('pr_delete_error_txt'),
                type: 'error',
              });
            });     
          }
        });
      },
      getNickName() {
        let index = this.userEdit.email.indexOf('@');
        if (index !== -1) {
          this.userEdit.nickName = this.userEdit.email.substring(0, index);
        }
      },
      showPrivacyPolicy() {
        let routeData = this.$router.resolve({name: 'privacyPolicy'});
        window.open(routeData.href, '_blank');          
      },
      changePassword() {
        this.$router.push({name: 'password'});
      },
      changeTypesList(event) {
        this.userEdit.artistTypesList = event;
        this.checkArtistType();
        // console.log(this.userEdit.artistTypesList);
        // this.updateUserProfile();
      },
      saveModalChanges() {
        // this.isChangedProps || this.isChangedEdu || this.isChangedExp ? this.updateUserProfile() : false;
      },
      checkArtistType() {
        this.userEdit.showHeightField = false;
        this.userEdit.artistTypesList.forEach(a => {
          if ((a.artistTypeName === 'Dancer') || (a.artistTypeName === 'Sportsman') || (a.artistTypeName === 'Circus artist')) {
            this.userEdit.showHeightField = true;
          }
        })
      },
    },
    beforeRouteLeave(to, from, next) {
      if (this.modalProps2 || this.modalEducEdit || this.modalExpiEdit) {
        this.modalProps2 ? this.$refs.modalProps2.$refs.cancel.click() : false;
        this.modalEducEdit ? this.$refs.modalEducEdit.$refs.cancel.click() : false;
        this.modalExpiEdit ? this.$refs.modalExpiEdit.$refs.cancel.click() : false;
        return next(false)
      } else {
        return next()
      }

    //   if (this.modalProps2) {
    //     this.$refs.modalProps2.propsHidden()
    //     return next(false)
    //   } else {
    //     return next()
    //   }
    }
  }
  </script>

  <style scoped>
    .content {
        background-color:#F7F7F8 !important;
        min-height: 100%;
        padding-left: 20px;
        padding-right: 20px;
        padding-top: 25px;
    }
    .card-cover {
        padding: 0;
        height: 280px;
    }
    .cover-img {
        width: 100%;
        height: 190px;
        background-size: cover;
        background-repeat: no-repeat; 
        border-radius: 0.25rem 0.25rem 0rem 0rem;
    }
    .user {
        text-align: right;
        text-transform: none;
        margin-top: -190px !important;
    }
    .user-title {
        text-align: left;
        text-transform: none;
        margin-top: -100px !important;
    }
    .avatar {
        width: 170px;
        height: auto !important;
        border: 5px solid #eee;
        position: relative;
        margin-bottom: 15px;
        background-color: white;
    }
    .avatar.border-gray {
        border-color: #eee;
        border-radius: 100px;
    }
    .card .user {
        font-size: 12px;
        font-weight: 600;
        overflow: hidden;
        margin: 0 auto;
        transition: all .3s linear
    }   
    .user-title .title {
        color: #565656;
        font-size: 1.6rem;
        font-weight: 500;
    }
    .user-title .title-tag {
        text-align: center;
        font-weight: normal;
        font-size: 1.2rem;
    }
    .user-title small {
        color: #9a9a9a;
        font-weight: 400;
        line-height: 1.5;
        font-size: 1rem;
    }
    .user-title small:hover {
       color: #9a9a9a;
       transition: all 0.3s;
    }
    .card .description {
        color: #565656;
        padding-bottom: 15px;
    }
    .btn-icon {
        text-align: left;
        padding-left: 10px;
        padding-bottom: 2px;
        padding-top: 5px;
        min-width: 1px !important;
        width: 38px;
        transition: all 0.3s;
        margin-left: 3px;
        margin-right: 3px;
        border: 1px solid #ff7777 !important;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
    .btn-icon:hover {
        width: 145px !important;
    }
    .btn-icon .fa {
        font-size: 20px;
    }
    .btn-icon .btn-txt {
        position: relative;
        bottom: 2px;
        margin-left: 10px;
        display: none;
    }
    .btn-icon:hover .btn-txt {
        display: inline;
    }
    .btn-icon-full {
        text-align: center;
        padding-left: 10px;
        padding-bottom: 2px;
        padding-top: 5px;
        -webkit-transition: all 0.3s;
        transition: all 0.3s;
        margin-left: 3px;
        margin-right: 3px;
        border: 2px solid #ff7777 !important;
        text-overflow: ellipsis;
        white-space: nowrap;
        background-color: transparent !important;
        color: red;
    }
    .btn-icon-full:hover {
        background-color: transparent !important;
        color: red;
    }
    .btn-icon-full .fa {
        font-size: 20px;
    }
    .btn-icon-full .btn-txt {
        position: relative;
        bottom: 2px;
        margin-left: 8px;
    }
    .user-btn-block {
        margin-top: -95px !important;
        text-align: left;
    }
    .message-modal {
        background-color: #A82D38 !important;
    }
    .input-message {
       height: 33px;
    }
    .text-message {
        height: 100px;
    }
    .form-control {
        border-radius: 4px;
        font-size: .975rem;
        color: #565656 !important;
        padding: 8px 12px;
    }
    .base-info-txt {
        color: #565656;
        font-size: 1rem;
    }
    .base-info-txt p {
        margin-bottom: 10px;
    }
    .base-info-txt .base-info-header {
        font-weight: 500;
        margin-bottom: 15px;
    }
    span.data,
    a.data {
        text-decoration: none;
        color: #565656;
        font-size: 1rem;
    }
    span.data:hover,
    a.data:hover {
        text-decoration: underline !important;
        cursor: pointer;
    }
    .image-gallery {
        border: 1px solid lightgray;
        border-radius: 10px;
    }
    .image-gallery-label {
        font-size: 1rem;
        color: #565656;
        font-weight: 600;
        margin-bottom: 5px;
        margin-top: 10px;
        margin-left: 5px;
        display: inline-block;
    }
    .row-gallery-title {
        margin-top: 20px;
    }
    .row-gallery {
        border: 1px solid rgba(0, 0, 0, 0.125);
        border-radius: 0.25rem;
        min-height: 212px;
        background-size: 180px;
        background-repeat: no-repeat;
        background-position-x: 15px;
        background-position-y: 15px;
    }
    .row-gallery-video {
        border: 1px solid rgba(0, 0, 0, 0.125);
        border-radius: 0.25rem;
        min-height: 212px;
        background-size: 180px;
        background-repeat: no-repeat;
        background-position-x: 15px;
        background-position-y: 15px;
    }
    .nomedia {
        background-image: url('../assets/img/no-media.png');
    }
    .cover-default {
        background: radial-gradient(ellipse at 65% 0%, #974450, #491b29 80%);
    }
    .image {
        float: left;
        background-size: cover;
        background-repeat: no-repeat;
        background-position: center center;
        border: 1px solid #ebebeb;
        margin: 5px;
    }
    .video {
        float: left;
        background-size: cover;
        background-repeat: no-repeat;
        background-position: center center;
        border: 1px solid #ebebeb;
        margin: 5px;
    }
    .collapseSkills {
        margin-top: 20px;
    }
    .btn-mobile-block {
        margin-bottom: 10px;
        margin-top: 10px;
    }
    .artistSkills {
        padding-top: 20px;
    }
    .additionalSkills {
        margin-bottom: 0 !important;
    }
    .more-info-btn {
        font-weight: 500;
    }
    .gallery-image {
            width: 300px !important;
            height: 200px;
            cursor: pointer;
            transition: all 0.3s;
    }
    .gallery-image:hover .overlay {
        height: 100%;
    }
    .overlay {
        position: relative;
        top: 0;
        left: 0;
        right: 0;
        background-color: #A82D38;
        overflow: hidden;
        width: 100%;
        height: 0;
        transition: .5s ease;
        opacity: 0.7;
    }
    .overlay-text {
        color: white;
        font-size: 1.2rem;
        position: absolute;
        overflow: hidden;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        -ms-transform: translate(-50%, -50%);
        font-weight: 600;
        text-shadow: 1px 1px 1px black;
        text-align: center;
        white-space: normal;
        word-wrap: break-word;
        padding-left: 10px;
        padding-right: 10px;
        width: inherit;
    }
    .add-video-btn,
    .add-image-btn {
        opacity: 0.5;
        cursor: pointer;
        transition: all 0.3s;
    }
    .add-video-btn:hover,
    .add-image-btn:hover {
        opacity: 1;
    }
    .add-video-btn .fa,
    .add-image-btn .fa{
        font-size: 0.8rem;
        margin-right: 5px;
        margin-left: 10px;
        font-weight: 400;
    }
    .select-btn {
        margin: 5px;
        background-color: white;
        color: #353535;
        border: 1px solid #ced4da;
    }
    .select-btn:hover {
        border: 1px solid #026ee2;
        transition: all .5s;
    }
    .select-btn:active {
        transform: scale(1.1);
        transition: all .3s;
    }
    .cover-text {
        padding-right: 5px;
        color: #565656;
    }
    .select-text {
        font-size:12px;
        line-height:1;
        margin-top:3px;
        color: #565656;
    }
    .form-radio {
        font-size: 22px !important;
    }

    .form-radio span {
        font-size: 18px !important;
        padding-left: 5px;
        margin-bottom: 5px;
    }
    .social-buttons-block {
        margin-left: 15px;
        position: relative;
        top: -2px;
    }
    .fa-info-block {
        padding-right: 5px;
        color: #46434385;
    }
    .manage-gallery-video {
        width: 95%;
        height: 115px;
        border-radius: 4px;
        -webkit-box-shadow: 2px 2px 11px 0px rgba(0,0,0,0.27);
        -moz-box-shadow: 2px 2px 11px 0px rgba(0,0,0,0.27);
        box-shadow: 2px 2px 11px 0px rgba(0,0,0,0.27);
        transition: all 0.3s;
        cursor: pointer;
    }
    .manage-gallery-video:hover {
        border-radius: 4px 4px 0 0;
    }
    .manage-gallery-image {
        width: 95%;
        height: 115px;
        border-radius: 4px;
        -webkit-box-shadow: 2px 2px 11px 0px rgba(0,0,0,0.27);
        -moz-box-shadow: 2px 2px 11px 0px rgba(0,0,0,0.27);
        box-shadow: 2px 2px 11px 0px rgba(0,0,0,0.27);
        transition: all 0.3s;
        cursor: pointer;
        background-size: cover;
        background-repeat: no-repeat;
    }
    .manage-gallery-image:hover {
        border-radius: 4px 4px 0 0;
    }
    .manage-col {
        padding-bottom: 20px;
    }
    .video-container {
        padding-top: 20px;
    }
    .video-container .overlay-manage {
        opacity: 0;
    }
    .video-container:hover .overlay-manage {
        height: 30px;
        opacity: 1;
    }
    .gallery-image:hover .overlay {
        height: 100%;
    }
    .overlay-manage {
        position: relative;
        top: 0;
        left: 0;
        right: 0;
        background-color: rgba(168, 45, 56, 0.7);
        overflow: hidden;
        width: 95%;
        height: 0;
        transition: .5s ease;
        opacity: 0.7;
        border-radius: 0 0 4px 4px;
    }
    .overlay-text-manage {
        color: white;
        font-size: 1.1rem;
        position: absolute;
        overflow: hidden;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        -ms-transform: translate(-50%, -50%);
        font-weight: 600;
        text-shadow: 1px 1px 1px black;
        text-align: center;
        white-space: normal;
        word-wrap: break-word;
        padding-left: 10px;
        padding-right: 10px;
        width: inherit;
    }
    .delete-file-btn {
        position: absolute;
        right: 15px;
        top: -4px;
    }
    .delete-file-btn .fa-times-circle {
        color: red;
        cursor: pointer;
        font-size: 22px;
        transition: all 0.3s;
    }
    .delete-file-btn .fa-times-circle:hover {
        transform: scale(1.2);
    }

    @media only screen and (max-width: 768px) {
        .col-mobile-margin {
            margin-bottom: 10px;
        }
        .avatar {
            width: 50% !important;
        }
        .gallery-image {
            width: 97% !important;
            height: 200px;
        }
        .user-title {
            padding-top: 50px;
        }
        .card .description {
            margin-top: 20px;
        }
        .subscription h1 {
            text-align: center;
        } 
    }
  </style>

  <style>
   .message-header {
        height: 30px !important;
        border-bottom: none !important;
        color: #A82D38 !important;
   }
   .message-header .close {
       padding-top: 3px !important;
       color: black !important;
   }
   .message-header h5 {
       font-size: 1rem !important;
       position: relative;
       top: -12px;
   }
   .message-footer {
       height: 50px !important;
       border-top: none !important;
   }
   .message-modal .modal-content {
       opacity: 1 !important;
   }
   .manage-gallery-modal .modal-content {
    opacity: 1 !important;
    }
    .manage-gallery-modal .modal-dialog {
        max-width: 700px !important;
    }
    .form-control:focus {
        border-color: rgba(168, 45, 56, 0.7) !important;
    }
    .preview-container {
        border-radius: 8px !important;
    }
    .preview-container > canvas {
        border: 1px solid #ced4da;
        border-radius: 10px;
    }
    .upload-img-title {
        margin-top: 20px;
    }
    .btns-upload {
        border-radius: 100px !important;
        padding-left: 20px !important;
        padding-right: 20px !important;
        padding-top: 3px !important;
        font-weight: 500 !important;
        height: 33px !important;
    }
    .picture-inner .picture-inner-text {
        font-size: 1.4rem !important;
        line-height: 1.4 !important;
    }
    @media only screen and (max-width: 768px) {
        .message-modal {
            margin-top: 0 !important;
        }
        .message-header h5 {
            font-size: 0.9rem !important;
        }
    }
    .btn-default.btn-add {
        color: #565656;
        background-color: white;
        border-color: #ced4da;
        width: 100% !important;
        margin-bottom: 25px;
        margin-top: 5px;
        cursor: pointer;
    }
    .btn-default.btn-add:hover {
        border-color: #565656;
    }
</style>

<style scoped>
  .editZone{
    width:49%;
    border: 1px solid lightgray;
    border-radius:5px;
    float:left;
    padding: 10px 10px 10px 10px;
    font-size:15px;    
  }

  .card {
      border-radius: 4px;
      background-color: #fff;
      margin-bottom: 30px;
  }

  .card {
    position: relative;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    min-width: 0;
    word-wrap: break-word;
    background-clip: border-box;
    border: 1px solid rgba(0, 0, 0, .125);
    border-radius: .25rem
  }

  .card>hr {
      margin-right: 0;
      margin-left: 0
  }

  .card>.list-group:first-child .list-group-item:first-child {
      border-top-left-radius: .25rem;
      border-top-right-radius: .25rem
  }

  .card>.list-group:last-child .list-group-item:last-child {
      border-bottom-right-radius: .25rem;
      border-bottom-left-radius: .25rem
  }

  .card-body {
    -webkit-box-flex: 1;
    -ms-flex: 1 1 auto;
    flex: 1 1 auto;
    padding: 1.25rem
  }

  .card .card-body {
    padding: 15px 15px 10px;
  }

  .card .card-header {
    padding: 15px 15px 0;
    background-color: #fff;
    border-bottom: none!important;
  }

  .card-header {
    padding: 0.75rem 1.25rem;
    margin-bottom: 0;
    background-color: rgba(255, 255, 255, 0.03);
    border-bottom: 1px solid rgba(255, 255, 255, 0.125);
  }

  .textarea-un-inside::-webkit-input-placeholder {
    color: #c0c4cc
  }

  .textarea-un-inside:-ms-input-placeholder {
    color: #c0c4cc
  }

  .textarea-un-inside::placeholder {
    color: #c0c4cc
  }

  .un-textarea.is-disabled .textarea-un-inside::-webkit-input-placeholder {
    color: #c0c4cc
  }

  .un-textarea.is-disabled .textarea-un-inside:-ms-input-placeholder {
      color: #c0c4cc
  }

  .un-textarea.is-disabled .textarea-un-inside::placeholder {
      color: #c0c4cc
  }

  .un-input-inside::-webkit-input-placeholder {
      color: #c0c4cc
  }

  .un-input-inside:-ms-input-placeholder {
      color: #c0c4cc
  }

  .un-input-inside::placeholder {
      color: #c0c4cc
  }

  .un-input.is-disabled .un-input-inside::-webkit-input-placeholder {
      color: #c0c4cc
  }

  .un-input.is-disabled .un-input-inside:-ms-input-placeholder {
      color: #c0c4cc
  }

  .un-input.is-disabled .un-input-inside::placeholder {
      color: #c0c4cc
  }

  .form-control::-webkit-input-placeholder {
    color: #6c757d;
    opacity: 1
  }

  .form-control:-ms-input-placeholder,
  .form-control::-ms-input-placeholder {
      color: #6c757d;
      opacity: 1
  }

  .form-control::placeholder {
      color: #6c757d;
      opacity: 1
  }

  .un-date-picker .un-input .un-input-inside:-moz-placeholder,
  .un-date-picker .un-input .un-input-inside::-moz-placeholder,
  .form-control:-moz-placeholder,
  .form-control::-moz-placeholder,
  .form-group .un-input-inside:-moz-placeholder,
  .form-group .un-input-inside::-moz-placeholder {
      color: #ddd;
      opacity: 1;
      filter: alpha(opacity=100)
  }

  .un-date-picker .un-input .un-input-inside::-webkit-input-placeholder,
  .form-control::-webkit-input-placeholder,
  .form-group .un-input-inside::-webkit-input-placeholder {
      color: rgb(207, 207, 207);
      opacity: 1;
      filter: alpha(opacity=100)
  }

  .un-date-picker .un-input .un-input-inside:-ms-input-placeholder,
  .form-control:-ms-input-placeholder,
  .form-group .un-input-inside:-ms-input-placeholder {
      color: #ddd;
      opacity: 1;
      filter: alpha(opacity=100)
  }

  .form-control:focus {
    border-color: rgba(168, 45, 56, 0.7) !important;
  }

  .form-control {
    background-color: #fff;
    border-radius: 4px;
    font-size: .975rem;
    color: #565656;
    padding: 8px 12px;
    height: 40px;
    box-shadow: none;
  }

  .form-control:disabled {
    background-color: #e9ecef !important;
    opacity: 1;
  }

  .un-select .un-input:hover .el-input__icon::placeholder,
  .un-select .un-input:hover input::placeholder {
      color: #fff
  }

  .select-default.un-select .un-input:hover .el-input__icon::placeholder,
  .select-default.un-select .un-input:hover input::placeholder {
      color: #fff
  }

  .select-info.un-select .un-input:hover .el-input__icon::placeholder,
  .select-info.un-select .un-input:hover input::placeholder {
      color: #fff
  }

  .select-primary.un-select .un-input:hover .el-input__icon::placeholder,
  .select-primary.un-select .un-input:hover input::placeholder {
      color: #fff
  }

  .select-success.un-select .un-input:hover .el-input__icon::placeholder,
  .select-success.un-select .un-input:hover input::placeholder {
    color: #fff
  }

  .select-warning.un-select .un-input:hover .el-input__icon::placeholder,
  .select-warning.un-select .un-input:hover input::placeholder {
      color: #fff
  }

  .select-danger.un-select .un-input:hover .el-input__icon::placeholder,
  .select-danger.un-select .un-input:hover input::placeholder {
      color: #fff
  }

  .form-group {
    margin-bottom: 1rem;
  }

  .card label {
    font-size: 14px;
    margin-bottom: 5px;
    text-transform: uppercase;
    font-weight: 400;
    color: #828080;
  }

  label {
    display: inline-block;
  }

  .textarea-un-inside {
    display: block;
    resize: vertical;
    padding: 5px 15px;
    line-height: 1.5;
    box-sizing: border-box;
    width: 100%;
    font-size: inherit;
    color: #606266;
    background-color: #fff;
    background-image: none;
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    transition: border-color .2s cubic-bezier(.645,.045,.355,1);
}

.card-profile .card-image {
    height: 110px !important;
}

.card-profile .card-image-plain {
    height: 0;
    margin-top: 110px;
}

.card-profile .avatar {
    width: 124px;
    height: 124px;
    border: 5px solid #eee;
    position: relative;
    margin-bottom: 15px;
    background-color: white;
}

.card-profile .avatar.border-gray {
    border-color: #eee;
    border-radius: 100px;
}

.card-profile .title {
    line-height: 24px
}

.card-profile .card-header.no-padding {
    padding: 0
}

.card-profile .card-footer .button-container .btn {
    font-size: 16px
}

.card-cost .card-footer,
.card-profile .card-footer {
    padding: 5px 15px 10px
}

.card-cost hr,
.card-profile hr {
    margin: 5px 15px;
    border-top: 1px solid rgb(187, 187, 187) !important;
}

.card .author {
    font-size: 12px;
    font-weight: 600;
    text-transform: uppercase;
    overflow: hidden;
    margin: 0 auto;
    transition: all .3s linear
}

.card .author i {
    font-size: 14px
}

.card.card-lock .card-header .author {
    width: 100px;
    height: 100px
}

.card-profile .author {
    text-align: center;
    text-transform: none;
    margin-top: -70px
}

.title {
  color: #565656;
}

.card-profile .title {
  line-height: 24px;
}

.author .title {
  color: #565656;
}

.p-title {
  color: #565656;
}

.p-title i {
  position: relative;
  top: 4px;
  font-size: 30px !important;
}

.card .description {
    color: #565656;
}

.card.card-profile .card-body {
  background-color: white !important;
}

h4 {
  font-size: 1.4rem;
}

h4 small, h5 .small, h5 small, h6 .small, h6 small {
    color: #9a9a9a;
    font-weight: 400;
    line-height: 1.5;
}

.small, small {
    font-size: 80%;
}

hr {
    border: 0;
    border-top: 1px solid rgba(0,0,0,.1) !important;
}

.fa-size {
  font-size: 20px;
}

.form-radio {
  font-size: 22px !important;
}

.form-radio span {
  font-size: 14px !important;
  padding-left: 5px;
  margin-bottom: 5px;
}

.fa-size2 {
  font-size: 16px;
}

.btn-wd {
  margin-bottom: 20px;
  margin-top: 15px;
}

.step-label {
  font-size: 25px; 
  color: #A82D38;
  font-weight: bold;
}

.step-text {
  position:relative;
  bottom: 4px;
  left:5px;
}

.croppa-container {
    background-color: white;
    border: 2px solid #dedede;
    border-style: dashed;
    border-radius: 4px;
    width: 184px;
    height: 184px;
    margin-bottom: 0;
    position: relative;
    margin-left: auto;
    margin-right: auto;
}

  input:disabled,
  select:disabled,
  button:disabled {
    color: #bdbdbd !important;
  }

.spinner {
  position: absolute;
  top: 50%;
  left: 50%;
  height: 70px;
  width: 70px;
  margin-left: -35px;
  margin-top: -35px;
  -webkit-animation: spin 1s linear infinite;
          animation: spin 1s linear infinite;
  border: 4px solid #ddd;
  border-top: 4px solid #42a5f5;
  border-radius: 50%;
}

@-webkit-keyframes spin {
  to {
    border-top-color: #ec407a;
    -webkit-transform: rotate(360deg);
            transform: rotate(360deg);
  }
}

@keyframes spin {
  to {
    border-top-color: #ec407a;
    -webkit-transform: rotate(360deg);
            transform: rotate(360deg);
  }
}

.crop-btn {
  font-size: 20px;
  cursor: pointer;
  color: #A82D38;
  margin: 5px;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: -moz-none;
  -o-user-select: none;
  user-select: none;
}

.crop-btn:hover {
  color: #026ee2;
  transition: all .3s;
}

.crop-btn:active {
  transform: scale(1.5);
}

.select-btn {
  margin: 5px;
  background-color: white;
  color: #353535;
  border: 1px solid #ced4da;
}

.select-btn:hover {
  border: 1px solid #026ee2;
  transition: all .5s;
}

.select-btn:active {
  transform: scale(1.1);
  transition: all .3s;
}

.select-text {
  font-size:12px;
  line-height:1;
  margin-top:3px;
  color: #565656;
}

.cover-text {
  padding-right: 5px;
  color: #565656;
}

.card-padding {
  padding-left: 10px !important;
  padding-right: 10px !important;
}

.btn.btn-default.btn-block {
  white-space: normal !important;
  padding-left: 0 !important;
  padding-right: 0 !important;
}

.p-title.title-collapse {
  margin-bottom: 0 !important;
  text-align: left;
  padding-left: 5px;
}

.customize-title {
  margin-bottom: 23px;
  padding-left: 5px;
}

.chevron-collapse {
  position: absolute;
  right: 12px;
  top: 22px;
  color: #565656;
  font-size: 20px;
}

div.card.mb-1 {
  border-right: none !important;
  border-left: none !important;
}

.card-body.b-1 {
  box-shadow: inset 0 7px 10px -7px rgba(0,0,0,.14);
  min-height: 100px !important;
}

.btn-shadow:hover {
  box-shadow: 0 5px 11px 0 rgba(0,0,0,0.18), 0 4px 15px 0 rgba(0,0,0,0.15);
}

.spinner.spinner-cover {
  margin-top: 2px;
}

@media only screen and (max-width: 768px) {
    #first {
        order: 1;
    }
    #second {
        order: 2;
    }
    #third {
        order: 3;
    }
    #fourth {
        order: 4;
    }
    .content {
      padding-top: 10px !important;
    }
}

.textarea-aboutme {
  min-height: 53px; 
  height: 84px;
}

.has-error:focus {
  border-color: #ea6a6a !important;
}

.cover-img {
  width: 100%;
  height: 150px;
  border-radius: 4px;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: top;
}

.card-header .title.title-header {
  display: inline-block;
}

.save-btn {
  background-color: #FB404B !important;
  border-color: #FB404B !important;
  font-weight: 500 !important;
  display: block;
  margin-left: 10px;
  height: 30px;
  padding: 0;
  float: left;
  padding-left: 10px;
  padding-right: 10px;
  position: fixed;
  bottom: 30px;
  opacity: 0.9;
  -webkit-animation: glowing 1700ms infinite;
  -moz-animation: glowing 1700ms infinite;
  -o-animation: glowing 1700ms infinite;
  animation: glowing 1700ms infinite;
}

.save-btn:hover {
  opacity: 1;
}

.save-btn-sync {
  display: block;
  margin-left: 77px;
  height: 30px;
  padding: 0;
  float: left;
  padding-left: 10px;
  padding-right: 10px;
  position: fixed;
  bottom: 30px;
  opacity: 0.9;
  /* -webkit-animation: glowing 1700ms infinite;
  -moz-animation: glowing 1700ms infinite;
  -o-animation: glowing 1700ms infinite;
  animation: glowing 1700ms infinite; */
}

.save-btn-sync:hover {
  opacity: 1;
}

.form-checkbox-modal {
  font-size: 22px !important;
}

.form-checkbox-modal span {
  font-size: 1rem;
  line-height: 1.2;
  color: black;
  padding-left: 5px;
  padding-right: 15px;
  display: inline-block;
  position: absolute;
}
.form-checkbox-modal span a {
  color: black !important;
  text-decoration: underline;
}
.delete-profile {
  color: rgb(143, 143, 143);
  text-decoration: underline;
  font-size: 14px;
  background-color: transparent;
  cursor: pointer;
  border: none;
  padding:0;
}
.delete-profile.password {
  padding-left: 15px;
}
.nowrap {
    white-space: nowrap;
}
.agreement-label {
  margin-top: 7px;
}
select.form-control option {
  font-size: 1rem !important;
}
p.danger {
  color: red !important;
  margin-top: 10px;
  margin-bottom: 0;
}

.cover-default {
  background: radial-gradient(ellipse at 65% 0%, #974450, #491b29 80%);
}

.btn-default.btn-add {
  color: #565656;
  background-color: white;
  border-color: #ced4da;
  width: 100% !important;
  margin-bottom: 25px;
  margin-top: 5px;
  cursor: pointer;
}
.btn-default.btn-add:hover {
  border-color: #565656;
}

.fa-angle-double-right {
  position: relative;
  left: -25px;
}

.reg-modal.password .btn-filter-alt-i {
  margin-top: 10px;
}

#city:read-only {
  background-color: transparent !important;
}

@-webkit-keyframes glowing {
  0% { background-color: #FB404B; -webkit-box-shadow: 0 0 3px #FB404B; }
  50% { background-color: #fd2432; -webkit-box-shadow: 0 0 20px #fd2432; }
  100% { background-color: #FB404B; -webkit-box-shadow: 0 0 3px #FB404B; }
}

@-moz-keyframes glowing {
  0% { background-color: #FB404B; -moz-box-shadow: 0 0 3px #FB404B; }
  50% { background-color: #fd2432; -moz-box-shadow: 0 0 20px #fd2432; }
  100% { background-color: #FB404B; -moz-box-shadow: 0 0 3px #FB404B; }
}

@-o-keyframes glowing {
  0% { background-color: #FB404B; box-shadow: 0 0 3px #FB404B; }
  50% { background-color: #fd2432; box-shadow: 0 0 20px #fd2432; }
  100% { background-color: #FB404B; box-shadow: 0 0 3px #FB404B; }
}

@keyframes glowing {
  0% { background-color: #FB404B; box-shadow: 0 0 3px #FB404B; }
  50% { background-color: #fd2432; box-shadow: 0 0 20px #fd2432; }
  100% { background-color: #FB404B; box-shadow: 0 0 3px #FB404B; }
}

@media only screen and (max-width: 768px) {
  .textarea-aboutme {
    min-height: 53px; 
    height: 150px;
  }
}
</style>

<style>
  .swal2-icon.swal2-warning {
    border-color: #FB404B !important;
    color: #FB404B !important;
  }
  .profile-delete-cancel {
    color: #555 !important;
    background-color: #efefef !important;
  }
  .form-radio span.modal-radio{
    font-size: 1rem !important;
    text-transform: uppercase;
    top: 7px;
    line-height: 1.2;
    padding-left: 5px;
    padding-right: 15px;
    display: inline-block;
    position: absolute;
  }
  .form-radio span.settings-radio{
    text-transform: uppercase;
    line-height: 1.2;
    padding-left: 5px;
    padding-right: 15px;
    display: inline-block;
    position: absolute;
    margin-top: 9px;
  }
  .reg-modal .modal-content {
    opacity: 1 !important;
  }
  .reg-modal .modal-dialog {
    max-width: 700px !important;
  }
  .reg-modal.password .modal-dialog {
    max-width: 400px !important;
  }
  .reg-modal p {
    text-transform: uppercase;
    font-weight: 500;
  }
  .reg-modal .danger {
    color: red !important;
    margin-top: 10px;
    margin-bottom: 0;
  }
  .row-agreement {
    margin-top: 20px;
  }
  .row-agreement .form-group {
    margin-bottom: 0;
  }
  .vdp-datepicker.reg-datepicker > div > input {
    width: 200px !important;
    border: 1px solid #343a40 !important;
  }
  .vdp-datepicker.reg-datepicker i {
    font-size: 30px;
    position: relative;
    top: 3px;
    padding-right: 5px;
    color: #A82D38;
  }
  .vdp-datepicker input::placeholder {
    color: rgb(206, 212, 218) !important;
  }
</style>

